 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

'use strict';

/**
 * Has been modified. Do not replace. - Michael Large
 *
 * Creates and uses srcSet attributes for background images.
 * @author Jesse Kernaghan <https://github.com/jessekernaghan/bgsrcset.js>
 */
(function () {
  'use strict';

  var bgsrcset = function bgsrcset() {

    this.called = false;
    this.callonce = true;
    this.compat();
  };

  bgsrcset.prototype.init = function (target, callback) {
    //retina bool
    this.retina = window.devicePixelRatio > 1;

    //storage for our elements
    this.elements = [];

    //global onload callback for imagery
    this.callback = typeof callback === 'function' ? callback : function () {};

    //window width, for responsive handling
    this.curwidth = this.getWidth();

    //get our input and turn it into an element list of some sort
    //   var elems = this.gather(target);
    var elems = document.querySelectorAll('[data-bg-srcset]');

    //parse the element input
    for (var i = 0, l = elems.length; i < l; i++) {
      this.parse(elems[i]);
    }

    this.set();
    this.resize();
  };

  /* -----------* /
     Fix compatibility issues*
     *only down to IE8
  / *----------- */

  bgsrcset.prototype.compat = function () {
    var d = document;
    /* check for getElementsByClassName */
    if (typeof d.getElementsByClassName !== 'function') {
      d.getElementsByClassName = function (str) {
        return d.querySelectorAll('.' + str);
      };
    }

    /* check for .trim() */
    if (!String.prototype.trim) {
      String.prototype.trim = function () {
        return this.replace(/^\s+|\s+$/g, '');
      };
    }

    /*------------------------* /
      Check for Event Listener
    / *------*/
    if (!d.addEventListener) {
      this.addEvent = function (elem, evName, fn) {
        elem.attachEvent('on' + evName, function (e) {
          fn(e || window.event);
        });
      };
    }
  };

  /* -----------* /
     Gather elements
  / *----------- */

  bgsrcset.prototype.gather = function (target) {
    var autotypes = ['HTMLCollection', 'NodeList'];
    var e = target;
    var type = e.nodeType ? 'Object' : Object.prototype.toString.call(e).replace(/^\[object |\]$/g, '');

    var func = 'parse' + type;

    if (autotypes.indexOf(type) > -1) {
      return e;
    }

    if (this[func]) {
      return this[func](e);
    }

    return [];
  };

  bgsrcset.prototype.parseObject = function (target) {
    return target.nodeType ? [target] : [];
  };

  bgsrcset.prototype.parseArray = function (target) {
    return target;
  };

  bgsrcset.prototype.parseString = function (target) {

    var d = document;
    var e = target.trim();
    var sel = e[0];
    var elems = [];

    switch (true) {
      /* class */
      case sel === '.':
        elems = d.getElementsByClassName(e.substring(1));
        break;
      /* id */
      case sel === '#':
        elems.push(d.getElementById(e.substring(1)));
        break;
      /* tag */
      case /^[a-zA-Z]+$/.test(e):
        elems = d.getElementsByTagName(e);
        break;
      /* unknown */
      default:
        elems = [];
    }

    return elems;
  };

  /* -----------* /
     Parse datasrc
  / *----------- */
  bgsrcset.prototype.parse = function (obj) {
    //our data to parase
    var bgss = obj.dataset.bgSrcset;
    /* exit if no attribute */
    if (attr === null) {
      console.log("NO BG SRCSET");return false;
    }

    /* create new element object */
    this.elements.push({});

    /* split up sets */
    var set = bgss.split(',');
    var attr = '';
    var curelem = this.elements[this.elements.length - 1];

    curelem.node = obj;
    curelem.srcset = [];

    /* loop through sets to define breakpoints */
    for (var i = 0, l = set.length; i < l; i++) {
      curelem.srcset.push({});
      attr = set[i].trim();
      var attrs = attr.split(' ');
      var a;
      var e;
      var t;
      /* since we can't know the order of the values, starting another loop */
      for (var attrc = 0, attrl = attrs.length; attrc < attrl; attrc++) {
        a = attrs[attrc];
        e = curelem.srcset[i]; //current attribute
        t = a.length - 1;
        switch (true) {
          case a.trim() === "":
            //in case of extra white spaces
            continue;
          case a[t] !== 'w' && a[a.length - 1] !== 'x':
            e.src = a;
            break;
          case a[t] === 'w':
            e.width = parseInt(a.slice(0, -1));
            break;
          case a[t] === 'x':
            e.retina = parseInt(a.slice(0, -1)) > 1;
            break;
        }
        if (!e.width) {
          e.width = Number.POSITIVE_INFINITY;
        } //set to the top
        if (!e.retina) {
          e.retina = false;
        }
      }
    }
  };

  /* -----------* /
     Set image
  / *----------- */
  bgsrcset.prototype.set = function () {
    for (var i = 0, l = this.elements.length; i < l; i++) {
      this.setSingle(i);
    }
  };

  bgsrcset.prototype.setSingle = function (id) {
    var width = 0,
        elem = this.elements[id],
        comparray = [],
        best = 0,
        _this = this;

    width = this.getWidth(); //elem.node.offsetWidth;

    elem.srcset = elem.srcset.sort(dynamicSort("width"));

    for (var i = 0, l = elem.srcset.length; i < l; i++) {
      if (elem.srcset[i].width < width) {
        continue;
      }
      comparray.push(elem.srcset[i]);
    }
    if (comparray.length === 0) {
      comparray.push(elem.srcset[elem.srcset.length - 1]);
    }

    best = comparray[0];

    if (comparray.length > 1 && comparray[0].width === comparray[1].width) {
      best = comparray[0].retina !== this.retina ? comparray[1] : comparray[0];
    }

    if (best.src !== undefined && best.src !== 'null') {
      var img = new Image();
      var done = false;

      img.onload = img.onreadystatechange = function () {
        if (!done && (!this.readyState || this.readyState === "loaded" || this.readyState === "complete")) {
          done = true;

          elem.node.style.backgroundImage = "url('" + best.src + "')";

          /* only fire the callback on initial load, not resize events */
          if (!_this.called) {

            _this.callback(elem);
            _this.called = _this.callonce;
          }
        }
      };

      img.src = best.src;
    } else {
      elem.node.style.backgroundImage = "";
    }
  };

  /* -----------* /
     Handle Resize
  / *----------- */
  bgsrcset.prototype.resize = function () {
    var _this = this,
        resizeTimer = setTimeout(function () {}, 0);

    this.addEvent(window, 'resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var w = _this.getWidth();
        if (w !== _this.curwidth) {
          _this.curwidth = w;
          _this.set();
        }
      }, 250);
    });
  };

  bgsrcset.prototype.addEvent = function (elem, evName, fn) {
    elem.addEventListener(evName, fn, false);
  };

  bgsrcset.prototype.getWidth = function () {
    var w, d, e, g;
    w = window;
    d = document;
    e = d.documentElement;
    g = d.getElementsByTagName('body')[0];

    return w.innerWidth || e.clientWidth || g.clientWidth;
  };

  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;a;
    };
  }

  window.bgsrcset = bgsrcset;
})();

// Creates SourceSet for background images.
var bgss = new bgsrcset();
bgss.init('.bgimg'); // Re-called in debug.js
 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

"use strict";

/**
* @file cookie.js
* Generic cookie handling functions.
* @author Hal Burgiss 2009-03-22
*/
function setCookie(name, value, days) {
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		var expires = "; expires=" + date.toGMTString();
	} else var expires = "";
	document.cookie = name + "=" + value + expires + "; path=/";
}
function readCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1, c.length);
		}if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
}
function eraseCookie(name) {
	setCookie(name, "", -1);
}
 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

'use strict';

/**
 * DBS Chevron hover
 */
window.addEventListener('load', function () {
	jQuery('#dbs-chev').on('click', function () {
		jQuery(this).toggleClass('hover');
	});
});
 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

'use strict';

/**
 * Debounce function for rate limiting a function.
 *
 * It prevents a function from being fired too frequently. This is useful
 * for resource intensive processes like resize event handlers and tap/click
 * handlers.
 *
 *
 * @see: https://davidwalsh.name/javascript-debounce-function
 *
 * @param function func - the callback function
 * @param int wait - the time to wait in milliseconds
 * @param bool immediate - call the function immediately
 *
 * @return function - the modified function that will only run once within a wait period.
 */
function debounce(func, wait, immediate) {
  var timeout;
  if (!wait) {
    console.warn("Debounce was called without a 'wait' argument. This renders debounce almost completely ineffective.");
  }
  return function () {
    var context = this,
        args = arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) {
        func.apply(context, args);
      }
    };

    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) {
      func.apply(context, args);
    }
  };
};

/**
 * Debounce scroll event for rate limiting scroll events.
 *
 * Putting events on the scroll handler should usually be discouraged
 * as they can be fired very frequently and this can cause the browser
 * to lag.
 *
 * Instead, use this event: debounceScroll
 *
 * This allows us to have only one scoll event handler that triggers
 * the debounceScoll event (on the window) 50ms (or whatever the
 * delay_time is set) after a scroll event starts and then stops.
 *
 *
 * @see: http://ejohn.org/blog/learning-from-twitter/#postcomment
 * (particularly read the comments for this variant)
 *
 * @usage:
 *
 *  	window.addEventListener( 'debounceScroll', function() {
 *  		console.log( 'scrolled....');
 *  	}, false );
 */

/**
 * A cross-browser compatible event creator function.
 */
function create_event(event_name) {
  if (typeof Event === 'function') {
    var event = new Event(event_name);
  } else {
    var event = document.createEvent('Event');
    event.initEvent(event_name, true, true);
  }
  return event;
}

var debounceScroll = create_event('debounceScroll');

jQuery(window).on('load', function () {
  var delay_time = 50;
  var delay_start = 0;
  var last_scroll_pos = 0;
  // The one scroll event handler to rule them all.
  jQuery(window).scroll(function (event) {
    // If we are already scrolling, reset the delay
    if (delay_start) {
      clearTimeout(delay_start);
    }

    // Are we scrolling down?
    var scrollDown = $(window).scrollTop() > last_scroll_pos;
    last_scroll_pos = $(window).scrollTop(); // Save for next time

    delay_start = setTimeout(function (event) {
      debounceScroll.scrollDown = scrollDown;
      window.dispatchEvent(debounceScroll);
    }, delay_time);
  });
});
 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

'use strict';

/*
 * jQuery Easing v1.3 - http://gsgd.co.uk/sandbox/jquery/easing/
 *
 * Uses the built in easing capabilities added In jQuery 1.1
 * to offer multiple easing options
 *
 * TERMS OF USE - jQuery Easing
 * 
 * Open source under the BSD License. 
 * 
 * Copyright © 2008 George McGinley Smith
 * All rights reserved.
 * 
 * Redistribution and use in source and binary forms, with or without modification, 
 * are permitted provided that the following conditions are met:
 * 
 * Redistributions of source code must retain the above copyright notice, this list of 
 * conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright notice, this list 
 * of conditions and the following disclaimer in the documentation and/or other materials 
 * provided with the distribution.
 * 
 * Neither the name of the author nor the names of contributors may be used to endorse 
 * or promote products derived from this software without specific prior written permission.
 * 
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY 
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 *  COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 *  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
 *  GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED 
 * AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 *  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED 
 * OF THE POSSIBILITY OF SUCH DAMAGE. 
 *
*/

// t: current time, b: begInnIng value, c: change In value, d: duration
jQuery.easing['jswing'] = jQuery.easing['swing'];

jQuery.extend(jQuery.easing, {
	def: 'easeOutQuad',
	swing: function swing(x, t, b, c, d) {
		//alert(jQuery.easing.default);
		return jQuery.easing[jQuery.easing.def](x, t, b, c, d);
	},
	easeInQuad: function easeInQuad(x, t, b, c, d) {
		return c * (t /= d) * t + b;
	},
	easeOutQuad: function easeOutQuad(x, t, b, c, d) {
		return -c * (t /= d) * (t - 2) + b;
	},
	easeInOutQuad: function easeInOutQuad(x, t, b, c, d) {
		if ((t /= d / 2) < 1) return c / 2 * t * t + b;
		return -c / 2 * (--t * (t - 2) - 1) + b;
	},
	easeInCubic: function easeInCubic(x, t, b, c, d) {
		return c * (t /= d) * t * t + b;
	},
	easeOutCubic: function easeOutCubic(x, t, b, c, d) {
		return c * ((t = t / d - 1) * t * t + 1) + b;
	},
	easeInOutCubic: function easeInOutCubic(x, t, b, c, d) {
		if ((t /= d / 2) < 1) return c / 2 * t * t * t + b;
		return c / 2 * ((t -= 2) * t * t + 2) + b;
	},
	easeInQuart: function easeInQuart(x, t, b, c, d) {
		return c * (t /= d) * t * t * t + b;
	},
	easeOutQuart: function easeOutQuart(x, t, b, c, d) {
		return -c * ((t = t / d - 1) * t * t * t - 1) + b;
	},
	easeInOutQuart: function easeInOutQuart(x, t, b, c, d) {
		if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
		return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
	},
	easeInQuint: function easeInQuint(x, t, b, c, d) {
		return c * (t /= d) * t * t * t * t + b;
	},
	easeOutQuint: function easeOutQuint(x, t, b, c, d) {
		return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
	},
	easeInOutQuint: function easeInOutQuint(x, t, b, c, d) {
		if ((t /= d / 2) < 1) return c / 2 * t * t * t * t * t + b;
		return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
	},
	easeInSine: function easeInSine(x, t, b, c, d) {
		return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
	},
	easeOutSine: function easeOutSine(x, t, b, c, d) {
		return c * Math.sin(t / d * (Math.PI / 2)) + b;
	},
	easeInOutSine: function easeInOutSine(x, t, b, c, d) {
		return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
	},
	easeInExpo: function easeInExpo(x, t, b, c, d) {
		return t == 0 ? b : c * Math.pow(2, 10 * (t / d - 1)) + b;
	},
	easeOutExpo: function easeOutExpo(x, t, b, c, d) {
		return t == d ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b;
	},
	easeInOutExpo: function easeInOutExpo(x, t, b, c, d) {
		if (t == 0) return b;
		if (t == d) return b + c;
		if ((t /= d / 2) < 1) return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
		return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
	},
	easeInCirc: function easeInCirc(x, t, b, c, d) {
		return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
	},
	easeOutCirc: function easeOutCirc(x, t, b, c, d) {
		return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
	},
	easeInOutCirc: function easeInOutCirc(x, t, b, c, d) {
		if ((t /= d / 2) < 1) return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
		return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
	},
	easeInElastic: function easeInElastic(x, t, b, c, d) {
		var s = 1.70158;var p = 0;var a = c;
		if (t == 0) return b;if ((t /= d) == 1) return b + c;if (!p) p = d * .3;
		if (a < Math.abs(c)) {
			a = c;var s = p / 4;
		} else var s = p / (2 * Math.PI) * Math.asin(c / a);
		return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
	},
	easeOutElastic: function easeOutElastic(x, t, b, c, d) {
		var s = 1.70158;var p = 0;var a = c;
		if (t == 0) return b;if ((t /= d) == 1) return b + c;if (!p) p = d * .3;
		if (a < Math.abs(c)) {
			a = c;var s = p / 4;
		} else var s = p / (2 * Math.PI) * Math.asin(c / a);
		return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b;
	},
	easeInOutElastic: function easeInOutElastic(x, t, b, c, d) {
		var s = 1.70158;var p = 0;var a = c;
		if (t == 0) return b;if ((t /= d / 2) == 2) return b + c;if (!p) p = d * (.3 * 1.5);
		if (a < Math.abs(c)) {
			a = c;var s = p / 4;
		} else var s = p / (2 * Math.PI) * Math.asin(c / a);
		if (t < 1) return -.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
		return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p) * .5 + c + b;
	},
	easeInBack: function easeInBack(x, t, b, c, d, s) {
		if (s == undefined) s = 1.70158;
		return c * (t /= d) * t * ((s + 1) * t - s) + b;
	},
	easeOutBack: function easeOutBack(x, t, b, c, d, s) {
		if (s == undefined) s = 1.70158;
		return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
	},
	easeInOutBack: function easeInOutBack(x, t, b, c, d, s) {
		if (s == undefined) s = 1.70158;
		if ((t /= d / 2) < 1) return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
		return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
	},
	easeInBounce: function easeInBounce(x, t, b, c, d) {
		return c - jQuery.easing.easeOutBounce(x, d - t, 0, c, d) + b;
	},
	easeOutBounce: function easeOutBounce(x, t, b, c, d) {
		if ((t /= d) < 1 / 2.75) {
			return c * (7.5625 * t * t) + b;
		} else if (t < 2 / 2.75) {
			return c * (7.5625 * (t -= 1.5 / 2.75) * t + .75) + b;
		} else if (t < 2.5 / 2.75) {
			return c * (7.5625 * (t -= 2.25 / 2.75) * t + .9375) + b;
		} else {
			return c * (7.5625 * (t -= 2.625 / 2.75) * t + .984375) + b;
		}
	},
	easeInOutBounce: function easeInOutBounce(x, t, b, c, d) {
		if (t < d / 2) return jQuery.easing.easeInBounce(x, t * 2, 0, c, d) * .5 + b;
		return jQuery.easing.easeOutBounce(x, t * 2 - d, 0, c, d) * .5 + c * .5 + b;
	}
});

/*
 *
 * TERMS OF USE - EASING EQUATIONS
 * 
 * Open source under the BSD License. 
 * 
 * Copyright © 2001 Robert Penner
 * All rights reserved.
 * 
 * Redistribution and use in source and binary forms, with or without modification, 
 * are permitted provided that the following conditions are met:
 * 
 * Redistributions of source code must retain the above copyright notice, this list of 
 * conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright notice, this list 
 * of conditions and the following disclaimer in the documentation and/or other materials 
 * provided with the distribution.
 * 
 * Neither the name of the author nor the names of contributors may be used to endorse 
 * or promote products derived from this software without specific prior written permission.
 * 
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY 
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 *  COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 *  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
 *  GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED 
 * AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 *  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED 
 * OF THE POSSIBILITY OF SUCH DAMAGE. 
 *
 */
 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

'use strict';

/**
 * Elements for extending the DOM with useful functionality.
 *
 * Note that caution should be used here as to prevent name collisions.
 * Probably only super useful functions should be included here.
 *
 * @usage:
 *
 * 	var element = document.getElementById( 'the_id' );
 *
 * 	element.onClickTap( function() {
 * 		// Do something useful when clicked or tapped but not dragged.
 * 		// Ignores annoying phantom clicks.
 * 	});
 *
 *
 * @author HGB3 12/22/2016
 */

/**
 * Sets up an event handler for both tap and click events in such a way
 * that we prevent "phantom taps" -- when both the click event and the
 * touchend events are fired for one event. Also tests for and ignores
 * drag events.
 *
 * @param function handler - the function to handle the event
 * @param element - element on which to put the events
 */
Element.prototype.onClickTap = function (handler, element) {
	var element = element || this; // Create a closure on the element

	var dragging = false; // Create a closure on a dragging flag

	/**
  * Notice and flag drag events to ignore.
  */
	jQuery(element).on('touchmove', function (event) {
		dragging = true;
	});

	/**
  * Handles touchend events (when not dragging).
  */
	jQuery(element).on('touchend', function (event) {
		if (!dragging) {
			handler(event);
		}
		dragging = false; // We are at the end of the 'touch', so reset dragging flag
		element.tapEventHandled = true;
	});

	/**
  * When this event is fired, check to see if the element's
  * tabEventHandled flag was set. If so, unset it.
  * If not, handle the event like normal.
  */
	jQuery(element).on('click', function (event) {
		if (element.tapEventHandled) {
			element.tapEventHandled = false;
			return;
		}
		if (!dragging) {
			handler(event);
		}
	});
};

/**
 * Sets up an event handler for *only* click events. Tap events, which
 * should happen first, will prevent the handler from being run.
 *
 * @param function handler - the function to handle the event
 */
Element.prototype.onClickTap = function (handler, element) {
	var element = element || this; // Create a closure on the element

	/**
  * Handles touchstart events.
  */
	jQuery(element).on('touchstart', function (event) {
		element.tapEventHappened = true;
	});

	/**
  * When this event is fired, check to see if the element's
  * tabEventHandled flag was set. If so, unset it for the next time.
  * If not, handle the event like normal.
  */
	jQuery(element).on('click', function (event) {
		if (element.tapEventHappened) {
			element.tapEventHappened = false;
		} else {
			handler(event);
		}
	});
};
 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

'use strict';

/**
 * Modal object for creating modals.
 *
 * @usage:
 *
 * 	var myModal = new Modal( element, { 'open' : true, 'onOpen' : myFunction );
 *
 * 	Assumes html like:
 *
 *  	<div class="modal">
 *  		<!-- a 'modal' can have more than one 'modal__box'es. -->
 *  		<div class="modal__box" >
 *  			<a href="#close" title="Close" class="modal__close_btn">Close</a>
 *  			<h2>A header</h2>
 *  			<p>A bunch of random text here. A bunch of random text here. And some more!</p>
 *  			<a href="#close" title="Close" class="modal__button" data-action="close">Continue</a>
 *  		</div>
 *  	</div>
 *
 *
 * @param element - DOM element that is the container for the modal
 * @param object - object containing optional attributes using this format:
 * 		{
 *
 * 			// When set, opens modal at creation.
 * 			'open' : false,
 *
 * 			// When set, clicking outside a modal box closes the modal.
 * 			'close_on_click_away' : true,
 *
 * 			// When set, displays only once (based on a cookie).
 * 			// TODO: not yet implemented
 * 			'show_once' : false,
 *
 * 			// Function to run when opening modal
 * 			'onOpen'  : function() {},
 *
 * 			// Function to run when closing modal
 * 			'onClose' : function() {},
 *
 * 		}
 *
 * @author HGB3 12/12/2016
 */
function Modal(element, atts) {

	// First try to use atts passed as an arg, if none were passed, try global modalAttributes.
	// Otherwise, just use an empty object
	if (!atts) {
		if (typeof modalAttributes !== 'undefined') {
			atts = modalAttributes;
		} else {
			atts = {};
		}
	}

	var attributes = { // If available, use passed attributes, otherwise use defaults
		'open': atts.open !== undefined ? atts.open : false,
		'close_on_click_away': atts.close_on_click_away !== undefined ? atts.close_on_click_away : true,
		'show_once': atts.show_once !== undefined ? atts.show_once : false,
		'onOpen': atts.onOpen || function () {},
		'onClose': atts.onClose || function () {}
	};

	if (!element) {
		// Sanity check
		console.warn('Cannot create Modal without modal element.');
		return;
	}

	this.element = element;

	this.name = jQuery(this.element).data('name');

	// Store a reference to the modal object on the element.
	this.element.modal = this;

	// Event Handlers

	var modal = this; // Closure on which to attach 'this'
	var close = function close() {
		modal.close();
	};

	jQuery(this.element).find('.modal__close_button').on('click', close);

	// For all modal buttons, set up event handler for action data attribute.
	jQuery('.modal__button').each(function (i, button) {
		var action = jQuery(button).data('action');
		if (action && modal[action]) {
			jQuery(button).on('click', function (event) {
				modal[action]();
				if (event) {
					event.preventDefault();
				}
			});
		}
	});

	if (attributes.close_on_click_away) {
		// Close when clicking the element (the area around the modal)...
		jQuery(this.element).on('click', close);

		// ...but don't allow click events to bubble up past modal boxes.
		// They should handle their own events.
		jQuery(this.element).find('.modal__box').on('click', function (event) {
			event.stopPropagation();
		});
	}

	// onOpen event handler
	this.onOpen = attributes.onOpen;

	// onClose event handler
	this.onClose = attributes.onClose;

	if (attributes.open) {
		this.open();
	}
}

/**
 * Hides the modal
 *
 * Adds hide class and removes show class on modal container element.
 * Animation should be done in stylesheets.
 */
Modal.prototype.hide = function () {
	jQuery(this.element).addClass('hide').removeClass('show');
};

/**
 * Shows the modal
 *
 * Adds show class and removes hide class on modal container element.
 * Animation should be done in stylesheets.
 */
Modal.prototype.show = function () {
	jQuery(this.element).addClass('show').removeClass('hide');
};

/**
 * Opens the modal
 * Also runs onOpen event handler.
 */
Modal.prototype.open = function () {
	this.show();
	this.onOpen();
};

/**
 * Closes the modal
 * Also runs onClose event handler.
 */
Modal.prototype.close = function () {
	this.hide();
	this.onClose();
};

/**
 * Automatically creates a modal object for every element that has a class of
 * 'modal'.
 */
jQuery(window).on('load', function () {

	// Store them in this array
	document.modals = [];

	jQuery('.modal').each(function (i, modal_element) {
		var name = jQuery(modal_element).data('name');
		var attributes = jQuery(modal_element).data('attributes');
		if (name) {
			var atts = attributes ? dbs.modals[attributes] : none;
			document.modals[name] = new Modal(modal_element, atts);
		} else {
			document.modals.push(new Modal(modal_element));
		}
	});
});
 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

'use strict';

/*
* Plugin Name: Resize Image to Parent Container
*
* Author: Christian Varga
* Author URI: http://christianvarga.com
* Plugin Source: https://github.com/levymetal/jquery-resize-image-to-parent/
*
*/

(function ($) {
	$.fn.resizeToParent = function (opts) {
		var defaults = {
			parent: 'div',
			contain: false,
			marginCenter: false,
			delay: 100
		};
		// console.log(opts.contain);

		var opts = $.extend(defaults, opts);

		function positionImage(obj) {
			// reset image (in case we're calling this a second time, for example on resize)
			//obj.css({'width': '', 'height': '', 'margin-left': '', 'margin-top': ''});
			if (opts.marginCenter) {
				obj.css({ 'width': '', 'height': '', 'margin-left': '', 'margin-top': 0 });
			} else {
				obj.css({ 'width': '', 'height': '', 'max-width': 'none' });
			}

			// dimensions of the parent
			var parentWidth = obj.parents(opts.parent).outerWidth() + 5; // To handle antialiasing
			var parentHeight = obj.parents(opts.parent).outerHeight() + 5; // To handle antialiasing

			// dimensions of the image
			var imageWidth = obj.width();
			var imageHeight = obj.height();

			// step 1 - calculate the percentage difference between image width and container width
			var diff = imageWidth / parentWidth;

			// step 2 - if height divided by difference is smaller than container height, resize by height. otherwise resize by width
			// console.log(opts.contain +' | '+ (imageHeight / diff) +' | '+ parentHeight);
			if (imageHeight / diff < parentHeight) {
				obj.css({ 'width': 'auto', 'height': parentHeight });

				// set image variables to new dimensions
				imageWidth = imageWidth / (imageHeight / parentHeight);
				imageHeight = parentHeight;
				// console.log('1');
				if (opts.contain) {
					obj.css({ 'height': 'auto', 'width': parentWidth });
				}
			} else {
				obj.css({ 'height': 'auto', 'width': parentWidth });

				// set image variables to new dimensions
				imageWidth = parentWidth;
				imageHeight = imageHeight / diff;
				// console.log('2');
				if (opts.contain) {
					obj.css({ 'width': 'auto', 'height': parentHeight });
				}
			}

			// step 3 - center image in container
			var leftOffset = (imageWidth - parentWidth) / -2;
			var topOffset = (imageHeight - parentHeight) / -2;

			//obj.css({'margin-left': leftOffset, 'margin-top': topOffset});
			if (opts.marginCenter) {
				obj.css({ 'margin-left': leftOffset, 'margin-top': 0 });
			}
		}

		// run the position function on window resize (to make it responsive)
		var tid;
		var elems = this;

		$(window).on('resize', function () {
			clearTimeout(tid);
			tid = setTimeout(function () {
				elems.each(function () {
					positionImage($(this));
				});
			}, opts.delay);
		});

		return this.each(function () {
			var obj = $(this);

			// hack to force ie to run the load function... ridiculous bug
			// http://stackoverflow.com/questions/7137737/ie9-problems-with-jquery-load-event-not-firing
			obj.attr("src", obj.attr("src"));

			// bind to load of image
			obj.load(function () {
				positionImage(obj);
			});

			// run the position function if the image is cached
			if (this.complete) {
				positionImage(obj);
			}
		});
	};
})(jQuery);
 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

"use strict";

/**
 * Slate Mobile Navigation Menu
 *
 */
(function ($) {

	"use strict";

	// Creates Var for Main (Header) Menu Hamburger Button.

	var $hamburger_menu_button = "<button class='menu-toggle' id='main-menu-toggle' title='Menu'><span class='menu-toggle__bar'></span><span class='menu-toggle__bar'></span><span class='menu-toggle__bar'></span></button>";

	// Creates Var for Menu Buttons (Which each expand a sub menu).
	var $expand_menu_button = "<button><span class='button-text'>Toggle Button</span></button>";

	// Selects elements that will have an "opened" appearance and a "closed"
	// appearance. Then adds a class of 'open' when that particular element
	// is clicked.
	$(".site-header__branding").after($hamburger_menu_button);
	$(document).on("click", "#main-menu-toggle", function () {
		if (!$(this).hasClass('open')) {
			$(this).addClass("open");
			$(".main-menu").addClass("open");
			$(".main-menu > ul[role='menu']").addClass("open");
			$(".site-mobile-overlay").addClass("open");
			if ($(".main-secondary-menu__item.search-form-menu__item").hasClass("open")) {
				$(".main-secondary-menu__item.search-form-menu__item").removeClass("open");
			}
		} else if ($(this).hasClass('open')) {
			$(this).removeClass('open');
			$(".main-menu").removeClass("open");
			$(".main-menu > ul[role='menu']").removeClass("open");
			$(".site-mobile-overlay").removeClass("open");
		}
	});

	// Click away code below for hamburger and search
	$(document).on("click", function () {
		if ($("#main-menu-toggle").hasClass('open')) {
			$("#main-menu-toggle").removeClass('open');
			$(".main-menu").removeClass("open");
			$(".main-menu > ul[role='menu']").removeClass("open");
			$(".site-mobile-overlay").removeClass("open");
		}
	});
	$(document).on("click", "#main-menu-toggle", function (e) {
		e.stopPropagation();
	});
	$(document).on("click", ".main-menu", function (e) {
		e.stopPropagation();
	});
	$(document).on("click", ".main-menu > ul[role='menu']", function (e) {
		e.stopPropagation();
	});

	// If class '.main-menu__item--parent' exists (indicating there is a submenu)
	// Go ahead and add a Menu Button (created in the var above) to give the user the
	// capability to expand the submenu.
	if ($(".main-menu__item--parent")) {
		$(".main-menu__item--parent > a").after($expand_menu_button);
	}

	// Add a class to the menu button when the user clicks it so that it has a
	// different appearance/style when clicked (indicating it has been activated)
	// and thus, the menu expanded.

	$(".main-menu__item--parent button").on("click", function () {
		$(this).toggleClass("rotated_expand-button");
		$(this).siblings("ul.main-menu__submenu").toggleClass("expanded_main-menu__submenu");
	});

	// On focus out event for last menu item in a sub-menu "set", check to see if menu has a button, and if it does, do nothing; otherwise if no button, let the natural order of "tabbing" change the focus from the child a to the child button take place and allow activation of child menu
	$(".main-menu__submenu > li:last-of-type > a").on("focusout", function () {
		// if li:last-of-type does have a button
		if ($(this).closest("li").has("button").length) {
			// (implied: do nothing on this particular focus change - i.e. do not toggle parent toggles)
			// if on focus change FROM button (which is the next natural option)
			$(this).closest("li").children("button").on("focusout", function () {
				// if this button (that we changed the focus from) HAS a class of "rotated_expand-button"
				if ($(this).hasClass("rotated_expand-button")) {
					// Do nothing
					// if this button (that we changed the focus from) does NOT HAVE a class of "rotated_expand-button"
				} else {
					// toggle parent elements' respective classes to "close" the immediate menu
					var expandedMainMenuSubmenu = $(this).closest(".expanded_main-menu__submenu");
					var expandedMainMenuSubmenuButton = $(this).closest(".expanded_main-menu__submenu").siblings("button.rotated_expand-button");
					$(expandedMainMenuSubmenu).toggleClass("expanded_main-menu__submenu");
					$(expandedMainMenuSubmenuButton).toggleClass("rotated_expand-button");
				}
			});
			// if li:last-of-type does not have a button
		} else {
			// find the immediate parent toggles and toggle them (to close menu and deactivate rotated menu button)
			var expandedMainMenuSubmenu = $(this).closest(".expanded_main-menu__submenu");
			var expandedMainMenuSubmenuButton = $(this).closest(".expanded_main-menu__submenu").siblings("button.rotated_expand-button");
			$(expandedMainMenuSubmenu).toggleClass("expanded_main-menu__submenu");
			$(expandedMainMenuSubmenuButton).toggleClass("rotated_expand-button");
		}
		// and if the focus happens to change to the next top-level parent, close prev menu
		$(this).closest("li.toplevel").next().children("a").on("focusin", function () {
			var previousSiblingMainMenuSubmenu = $(this).closest("li.toplevel").prev("li.toplevel").children("ul.expanded_main-menu__submenu");
			var previousSiblingMainMenuSubmenuButton = $(this).closest("li.toplevel").prev("li.toplevel").children("button.rotated_expand-button");
			$(previousSiblingMainMenuSubmenu).toggleClass("expanded_main-menu__submenu");
			$(previousSiblingMainMenuSubmenuButton).toggleClass("rotated_expand-button");
		});
	});
})(jQuery);

// Adds a "tabindex" attribute to what "should be tab-able" elements -- OPTIONAL
// This isn't necessary IF tabindex attribute doesn't contribute to some sort of solution for FF and Safari tabbing issues; caused by those respective vendors, but not necessarily the markup.
jQuery(function () {
	var tabIndexEls = $("ul[role='menu']").find("li > a");
	$(tabIndexEls).each(function (index) {
		$(this).attr("tabindex", 0);
	});
});
 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.6.0
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
/* global window, document, define, jQuery, setInterval, clearInterval */
(function (factory) {
    'use strict';

    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof exports !== 'undefined') {
        module.exports = factory(require('jquery'));
    } else {
        factory(jQuery);
    }
})(function ($) {
    'use strict';

    var Slick = window.Slick || {};

    Slick = function () {

        var instanceUid = 0;

        function Slick(element, settings) {

            var _ = this,
                dataSettings;

            _.defaults = {
                accessibility: true,
                adaptiveHeight: false,
                appendArrows: $(element),
                appendDots: $(element),
                arrows: true,
                asNavFor: null,
                prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
                nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',
                autoplay: false,
                autoplaySpeed: 3000,
                centerMode: false,
                centerPadding: '50px',
                cssEase: 'ease',
                customPaging: function customPaging(slider, i) {
                    return $('<button type="button" data-role="none" role="button" tabindex="0" />').text(i + 1);
                },
                dots: false,
                dotsClass: 'slick-dots',
                draggable: true,
                easing: 'linear',
                edgeFriction: 0.35,
                fade: false,
                focusOnSelect: false,
                infinite: true,
                initialSlide: 0,
                lazyLoad: 'ondemand',
                mobileFirst: false,
                pauseOnHover: true,
                pauseOnFocus: true,
                pauseOnDotsHover: false,
                respondTo: 'window',
                responsive: null,
                rows: 1,
                rtl: false,
                slide: '',
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                touchThreshold: 5,
                useCSS: true,
                useTransform: true,
                variableWidth: false,
                vertical: false,
                verticalSwiping: false,
                waitForAnimate: true,
                zIndex: 1000
            };

            _.initials = {
                animating: false,
                dragging: false,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: false,
                slideOffset: 0,
                swipeLeft: null,
                $list: null,
                touchObject: {},
                transformsEnabled: false,
                unslicked: false
            };

            $.extend(_, _.initials);

            _.activeBreakpoint = null;
            _.animType = null;
            _.animProp = null;
            _.breakpoints = [];
            _.breakpointSettings = [];
            _.cssTransitions = false;
            _.focussed = false;
            _.interrupted = false;
            _.hidden = 'hidden';
            _.paused = true;
            _.positionProp = null;
            _.respondTo = null;
            _.rowCount = 1;
            _.shouldClick = true;
            _.$slider = $(element);
            _.$slidesCache = null;
            _.transformType = null;
            _.transitionType = null;
            _.visibilityChange = 'visibilitychange';
            _.windowWidth = 0;
            _.windowTimer = null;

            dataSettings = $(element).data('slick') || {};

            _.options = $.extend({}, _.defaults, settings, dataSettings);

            _.currentSlide = _.options.initialSlide;

            _.originalSettings = _.options;

            if (typeof document.mozHidden !== 'undefined') {
                _.hidden = 'mozHidden';
                _.visibilityChange = 'mozvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                _.hidden = 'webkitHidden';
                _.visibilityChange = 'webkitvisibilitychange';
            }

            _.autoPlay = $.proxy(_.autoPlay, _);
            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
            _.changeSlide = $.proxy(_.changeSlide, _);
            _.clickHandler = $.proxy(_.clickHandler, _);
            _.selectHandler = $.proxy(_.selectHandler, _);
            _.setPosition = $.proxy(_.setPosition, _);
            _.swipeHandler = $.proxy(_.swipeHandler, _);
            _.dragHandler = $.proxy(_.dragHandler, _);
            _.keyHandler = $.proxy(_.keyHandler, _);

            _.instanceUid = instanceUid++;

            // A simple way to check for HTML strings
            // Strict HTML recognition (must start with <)
            // Extracted from jQuery v1.11 source
            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;

            _.registerBreakpoints();
            _.init(true);
        }

        return Slick;
    }();

    Slick.prototype.activateADA = function () {
        var _ = this;

        _.$slideTrack.find('.slick-active').attr({
            'aria-hidden': 'false'
        }).find('a, input, button, select').attr({
            'tabindex': '0'
        });
    };

    Slick.prototype.addSlide = Slick.prototype.slickAdd = function (markup, index, addBefore) {

        var _ = this;

        if (typeof index === 'boolean') {
            addBefore = index;
            index = null;
        } else if (index < 0 || index >= _.slideCount) {
            return false;
        }

        _.unload();

        if (typeof index === 'number') {
            if (index === 0 && _.$slides.length === 0) {
                $(markup).appendTo(_.$slideTrack);
            } else if (addBefore) {
                $(markup).insertBefore(_.$slides.eq(index));
            } else {
                $(markup).insertAfter(_.$slides.eq(index));
            }
        } else {
            if (addBefore === true) {
                $(markup).prependTo(_.$slideTrack);
            } else {
                $(markup).appendTo(_.$slideTrack);
            }
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slides.each(function (index, element) {
            $(element).attr('data-slick-index', index);
        });

        _.$slidesCache = _.$slides;

        _.reinit();
    };

    Slick.prototype.animateHeight = function () {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.animate({
                height: targetHeight
            }, _.options.speed);
        }
    };

    Slick.prototype.animateSlide = function (targetLeft, callback) {

        var animProps = {},
            _ = this;

        _.animateHeight();

        if (_.options.rtl === true && _.options.vertical === false) {
            targetLeft = -targetLeft;
        }
        if (_.transformsEnabled === false) {
            if (_.options.vertical === false) {
                _.$slideTrack.animate({
                    left: targetLeft
                }, _.options.speed, _.options.easing, callback);
            } else {
                _.$slideTrack.animate({
                    top: targetLeft
                }, _.options.speed, _.options.easing, callback);
            }
        } else {

            if (_.cssTransitions === false) {
                if (_.options.rtl === true) {
                    _.currentLeft = -_.currentLeft;
                }
                $({
                    animStart: _.currentLeft
                }).animate({
                    animStart: targetLeft
                }, {
                    duration: _.options.speed,
                    easing: _.options.easing,
                    step: function step(now) {
                        now = Math.ceil(now);
                        if (_.options.vertical === false) {
                            animProps[_.animType] = 'translate(' + now + 'px, 0px)';
                            _.$slideTrack.css(animProps);
                        } else {
                            animProps[_.animType] = 'translate(0px,' + now + 'px)';
                            _.$slideTrack.css(animProps);
                        }
                    },
                    complete: function complete() {
                        if (callback) {
                            callback.call();
                        }
                    }
                });
            } else {

                _.applyTransition();
                targetLeft = Math.ceil(targetLeft);

                if (_.options.vertical === false) {
                    animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
                } else {
                    animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
                }
                _.$slideTrack.css(animProps);

                if (callback) {
                    setTimeout(function () {

                        _.disableTransition();

                        callback.call();
                    }, _.options.speed);
                }
            }
        }
    };

    Slick.prototype.getNavTarget = function () {

        var _ = this,
            asNavFor = _.options.asNavFor;

        if (asNavFor && asNavFor !== null) {
            asNavFor = $(asNavFor).not(_.$slider);
        }

        return asNavFor;
    };

    Slick.prototype.asNavFor = function (index) {

        var _ = this,
            asNavFor = _.getNavTarget();

        if (asNavFor !== null && (typeof asNavFor === 'undefined' ? 'undefined' : _typeof(asNavFor)) === 'object') {
            asNavFor.each(function () {
                var target = $(this).slick('getSlick');
                if (!target.unslicked) {
                    target.slideHandler(index, true);
                }
            });
        }
    };

    Slick.prototype.applyTransition = function (slide) {

        var _ = this,
            transition = {};

        if (_.options.fade === false) {
            transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
        } else {
            transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
        }

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }
    };

    Slick.prototype.autoPlay = function () {

        var _ = this;

        _.autoPlayClear();

        if (_.slideCount > _.options.slidesToShow) {
            _.autoPlayTimer = setInterval(_.autoPlayIterator, _.options.autoplaySpeed);
        }
    };

    Slick.prototype.autoPlayClear = function () {

        var _ = this;

        if (_.autoPlayTimer) {
            clearInterval(_.autoPlayTimer);
        }
    };

    Slick.prototype.autoPlayIterator = function () {

        var _ = this,
            slideTo = _.currentSlide + _.options.slidesToScroll;

        if (!_.paused && !_.interrupted && !_.focussed) {

            if (_.options.infinite === false) {

                if (_.direction === 1 && _.currentSlide + 1 === _.slideCount - 1) {
                    _.direction = 0;
                } else if (_.direction === 0) {

                    slideTo = _.currentSlide - _.options.slidesToScroll;

                    if (_.currentSlide - 1 === 0) {
                        _.direction = 1;
                    }
                }
            }

            _.slideHandler(slideTo);
        }
    };

    Slick.prototype.buildArrows = function () {

        var _ = this;

        if (_.options.arrows === true) {

            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');

            if (_.slideCount > _.options.slidesToShow) {

                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');

                if (_.htmlExpr.test(_.options.prevArrow)) {
                    _.$prevArrow.prependTo(_.options.appendArrows);
                }

                if (_.htmlExpr.test(_.options.nextArrow)) {
                    _.$nextArrow.appendTo(_.options.appendArrows);
                }

                if (_.options.infinite !== true) {
                    _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                }
            } else {

                _.$prevArrow.add(_.$nextArrow).addClass('slick-hidden').attr({
                    'aria-disabled': 'true',
                    'tabindex': '-1'
                });
            }
        }
    };

    Slick.prototype.buildDots = function () {

        var _ = this,
            i,
            dot;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$slider.addClass('slick-dotted');

            dot = $('<ul />').addClass(_.options.dotsClass);

            for (i = 0; i <= _.getDotCount(); i += 1) {
                dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
            }

            _.$dots = dot.appendTo(_.options.appendDots);

            _.$dots.find('li').first().addClass('slick-active').attr('aria-hidden', 'false');
        }
    };

    Slick.prototype.buildOut = function () {

        var _ = this;

        _.$slides = _.$slider.children(_.options.slide + ':not(.slick-cloned)').addClass('slick-slide');

        _.slideCount = _.$slides.length;

        _.$slides.each(function (index, element) {
            $(element).attr('data-slick-index', index).data('originalStyling', $(element).attr('style') || '');
        });

        _.$slider.addClass('slick-slider');

        _.$slideTrack = _.slideCount === 0 ? $('<div class="slick-track"/>').appendTo(_.$slider) : _.$slides.wrapAll('<div class="slick-track"/>').parent();

        _.$list = _.$slideTrack.wrap('<div aria-live="polite" class="slick-list"/>').parent();
        _.$slideTrack.css('opacity', 0);

        if (_.options.centerMode === true || _.options.swipeToSlide === true) {
            _.options.slidesToScroll = 1;
        }

        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');

        _.setupInfinite();

        _.buildArrows();

        _.buildDots();

        _.updateDots();

        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        if (_.options.draggable === true) {
            _.$list.addClass('draggable');
        }
    };

    Slick.prototype.buildRows = function () {

        var _ = this,
            a,
            b,
            c,
            newSlides,
            numOfSlides,
            originalSlides,
            slidesPerSection;

        newSlides = document.createDocumentFragment();
        originalSlides = _.$slider.children();

        if (_.options.rows > 1) {

            slidesPerSection = _.options.slidesPerRow * _.options.rows;
            numOfSlides = Math.ceil(originalSlides.length / slidesPerSection);

            for (a = 0; a < numOfSlides; a++) {
                var slide = document.createElement('div');
                for (b = 0; b < _.options.rows; b++) {
                    var row = document.createElement('div');
                    for (c = 0; c < _.options.slidesPerRow; c++) {
                        var target = a * slidesPerSection + (b * _.options.slidesPerRow + c);
                        if (originalSlides.get(target)) {
                            row.appendChild(originalSlides.get(target));
                        }
                    }
                    slide.appendChild(row);
                }
                newSlides.appendChild(slide);
            }

            _.$slider.empty().append(newSlides);
            _.$slider.children().children().children().css({
                'width': 100 / _.options.slidesPerRow + '%',
                'display': 'inline-block'
            });
        }
    };

    Slick.prototype.checkResponsive = function (initial, forceUpdate) {

        var _ = this,
            breakpoint,
            targetBreakpoint,
            respondToWidth,
            triggerBreakpoint = false;
        var sliderWidth = _.$slider.width();
        var windowWidth = window.innerWidth || $(window).width();

        if (_.respondTo === 'window') {
            respondToWidth = windowWidth;
        } else if (_.respondTo === 'slider') {
            respondToWidth = sliderWidth;
        } else if (_.respondTo === 'min') {
            respondToWidth = Math.min(windowWidth, sliderWidth);
        }

        if (_.options.responsive && _.options.responsive.length && _.options.responsive !== null) {

            targetBreakpoint = null;

            for (breakpoint in _.breakpoints) {
                if (_.breakpoints.hasOwnProperty(breakpoint)) {
                    if (_.originalSettings.mobileFirst === false) {
                        if (respondToWidth < _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    } else {
                        if (respondToWidth > _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    }
                }
            }

            if (targetBreakpoint !== null) {
                if (_.activeBreakpoint !== null) {
                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
                        _.activeBreakpoint = targetBreakpoint;
                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                            _.unslick(targetBreakpoint);
                        } else {
                            _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
                            if (initial === true) {
                                _.currentSlide = _.options.initialSlide;
                            }
                            _.refresh(initial);
                        }
                        triggerBreakpoint = targetBreakpoint;
                    }
                } else {
                    _.activeBreakpoint = targetBreakpoint;
                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                        _.unslick(targetBreakpoint);
                    } else {
                        _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
                        if (initial === true) {
                            _.currentSlide = _.options.initialSlide;
                        }
                        _.refresh(initial);
                    }
                    triggerBreakpoint = targetBreakpoint;
                }
            } else {
                if (_.activeBreakpoint !== null) {
                    _.activeBreakpoint = null;
                    _.options = _.originalSettings;
                    if (initial === true) {
                        _.currentSlide = _.options.initialSlide;
                    }
                    _.refresh(initial);
                    triggerBreakpoint = targetBreakpoint;
                }
            }

            // only trigger breakpoints during an actual break. not on initialize.
            if (!initial && triggerBreakpoint !== false) {
                _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
            }
        }
    };

    Slick.prototype.changeSlide = function (event, dontAnimate) {

        var _ = this,
            $target = $(event.currentTarget),
            indexOffset,
            slideOffset,
            unevenOffset;

        // If target is a link, prevent default action.
        if ($target.is('a')) {
            event.preventDefault();
        }

        // If target is not the <li> element (ie: a child), find the <li>.
        if (!$target.is('li')) {
            $target = $target.closest('li');
        }

        unevenOffset = _.slideCount % _.options.slidesToScroll !== 0;
        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;

        switch (event.data.message) {

            case 'previous':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
                }
                break;

            case 'next':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
                }
                break;

            case 'index':
                var index = event.data.index === 0 ? 0 : event.data.index || $target.index() * _.options.slidesToScroll;

                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
                $target.children().trigger('focus');
                break;

            default:
                return;
        }
    };

    Slick.prototype.checkNavigable = function (index) {

        var _ = this,
            navigables,
            prevNavigable;

        navigables = _.getNavigableIndexes();
        prevNavigable = 0;
        if (index > navigables[navigables.length - 1]) {
            index = navigables[navigables.length - 1];
        } else {
            for (var n in navigables) {
                if (index < navigables[n]) {
                    index = prevNavigable;
                    break;
                }
                prevNavigable = navigables[n];
            }
        }

        return index;
    };

    Slick.prototype.cleanUpEvents = function () {

        var _ = this;

        if (_.options.dots && _.$dots !== null) {

            $('li', _.$dots).off('click.slick', _.changeSlide).off('mouseenter.slick', $.proxy(_.interrupt, _, true)).off('mouseleave.slick', $.proxy(_.interrupt, _, false));
        }

        _.$slider.off('focus.slick blur.slick');

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);
        }

        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);

        _.$list.off('click.slick', _.clickHandler);

        $(document).off(_.visibilityChange, _.visibility);

        _.cleanUpSlideEvents();

        if (_.options.accessibility === true) {
            _.$list.off('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().off('click.slick', _.selectHandler);
        }

        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);

        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);

        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);

        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);
        $(document).off('ready.slick.slick-' + _.instanceUid, _.setPosition);
    };

    Slick.prototype.cleanUpSlideEvents = function () {

        var _ = this;

        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));
    };

    Slick.prototype.cleanUpRows = function () {

        var _ = this,
            originalSlides;

        if (_.options.rows > 1) {
            originalSlides = _.$slides.children().children();
            originalSlides.removeAttr('style');
            _.$slider.empty().append(originalSlides);
        }
    };

    Slick.prototype.clickHandler = function (event) {

        var _ = this;

        if (_.shouldClick === false) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
        }
    };

    Slick.prototype.destroy = function (refresh) {

        var _ = this;

        _.autoPlayClear();

        _.touchObject = {};

        _.cleanUpEvents();

        $('.slick-cloned', _.$slider).detach();

        if (_.$dots) {
            _.$dots.remove();
        }

        if (_.$prevArrow && _.$prevArrow.length) {

            _.$prevArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');

            if (_.htmlExpr.test(_.options.prevArrow)) {
                _.$prevArrow.remove();
            }
        }

        if (_.$nextArrow && _.$nextArrow.length) {

            _.$nextArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');

            if (_.htmlExpr.test(_.options.nextArrow)) {
                _.$nextArrow.remove();
            }
        }

        if (_.$slides) {

            _.$slides.removeClass('slick-slide slick-active slick-center slick-visible slick-current').removeAttr('aria-hidden').removeAttr('data-slick-index').each(function () {
                $(this).attr('style', $(this).data('originalStyling'));
            });

            _.$slideTrack.children(this.options.slide).detach();

            _.$slideTrack.detach();

            _.$list.detach();

            _.$slider.append(_.$slides);
        }

        _.cleanUpRows();

        _.$slider.removeClass('slick-slider');
        _.$slider.removeClass('slick-initialized');
        _.$slider.removeClass('slick-dotted');

        _.unslicked = true;

        if (!refresh) {
            _.$slider.trigger('destroy', [_]);
        }
    };

    Slick.prototype.disableTransition = function (slide) {

        var _ = this,
            transition = {};

        transition[_.transitionType] = '';

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }
    };

    Slick.prototype.fadeSlide = function (slideIndex, callback) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).css({
                zIndex: _.options.zIndex
            });

            _.$slides.eq(slideIndex).animate({
                opacity: 1
            }, _.options.speed, _.options.easing, callback);
        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 1,
                zIndex: _.options.zIndex
            });

            if (callback) {
                setTimeout(function () {

                    _.disableTransition(slideIndex);

                    callback.call();
                }, _.options.speed);
            }
        }
    };

    Slick.prototype.fadeSlideOut = function (slideIndex) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).animate({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            }, _.options.speed, _.options.easing);
        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            });
        }
    };

    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function (filter) {

        var _ = this;

        if (filter !== null) {

            _.$slidesCache = _.$slides;

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);

            _.reinit();
        }
    };

    Slick.prototype.focusHandler = function () {

        var _ = this;

        _.$slider.off('focus.slick blur.slick').on('focus.slick blur.slick', '*:not(.slick-arrow)', function (event) {

            event.stopImmediatePropagation();
            var $sf = $(this);

            setTimeout(function () {

                if (_.options.pauseOnFocus) {
                    _.focussed = $sf.is(':focus');
                    _.autoPlay();
                }
            }, 0);
        });
    };

    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function () {

        var _ = this;
        return _.currentSlide;
    };

    Slick.prototype.getDotCount = function () {

        var _ = this;

        var breakPoint = 0;
        var counter = 0;
        var pagerQty = 0;

        if (_.options.infinite === true) {
            while (breakPoint < _.slideCount) {
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        } else if (_.options.centerMode === true) {
            pagerQty = _.slideCount;
        } else if (!_.options.asNavFor) {
            pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
        } else {
            while (breakPoint < _.slideCount) {
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        }

        return pagerQty - 1;
    };

    Slick.prototype.getLeft = function (slideIndex) {

        var _ = this,
            targetLeft,
            verticalHeight,
            verticalOffset = 0,
            targetSlide;

        _.slideOffset = 0;
        verticalHeight = _.$slides.first().outerHeight(true);

        if (_.options.infinite === true) {
            if (_.slideCount > _.options.slidesToShow) {
                _.slideOffset = _.slideWidth * _.options.slidesToShow * -1;
                verticalOffset = verticalHeight * _.options.slidesToShow * -1;
            }
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                    if (slideIndex > _.slideCount) {
                        _.slideOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth * -1;
                        verticalOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight * -1;
                    } else {
                        _.slideOffset = _.slideCount % _.options.slidesToScroll * _.slideWidth * -1;
                        verticalOffset = _.slideCount % _.options.slidesToScroll * verticalHeight * -1;
                    }
                }
            }
        } else {
            if (slideIndex + _.options.slidesToShow > _.slideCount) {
                _.slideOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * _.slideWidth;
                verticalOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * verticalHeight;
            }
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.slideOffset = 0;
            verticalOffset = 0;
        }

        if (_.options.centerMode === true && _.options.infinite === true) {
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
        } else if (_.options.centerMode === true) {
            _.slideOffset = 0;
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
        }

        if (_.options.vertical === false) {
            targetLeft = slideIndex * _.slideWidth * -1 + _.slideOffset;
        } else {
            targetLeft = slideIndex * verticalHeight * -1 + verticalOffset;
        }

        if (_.options.variableWidth === true) {

            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
            } else {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
            }

            if (_.options.rtl === true) {
                if (targetSlide[0]) {
                    targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                } else {
                    targetLeft = 0;
                }
            } else {
                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
            }

            if (_.options.centerMode === true) {
                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
                } else {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
                }

                if (_.options.rtl === true) {
                    if (targetSlide[0]) {
                        targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                    } else {
                        targetLeft = 0;
                    }
                } else {
                    targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
                }

                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
            }
        }

        return targetLeft;
    };

    Slick.prototype.getOption = Slick.prototype.slickGetOption = function (option) {

        var _ = this;

        return _.options[option];
    };

    Slick.prototype.getNavigableIndexes = function () {

        var _ = this,
            breakPoint = 0,
            counter = 0,
            indexes = [],
            max;

        if (_.options.infinite === false) {
            max = _.slideCount;
        } else {
            breakPoint = _.options.slidesToScroll * -1;
            counter = _.options.slidesToScroll * -1;
            max = _.slideCount * 2;
        }

        while (breakPoint < max) {
            indexes.push(breakPoint);
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }

        return indexes;
    };

    Slick.prototype.getSlick = function () {

        return this;
    };

    Slick.prototype.getSlideCount = function () {

        var _ = this,
            slidesTraversed,
            swipedSlide,
            centerOffset;

        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;

        if (_.options.swipeToSlide === true) {
            _.$slideTrack.find('.slick-slide').each(function (index, slide) {
                if (slide.offsetLeft - centerOffset + $(slide).outerWidth() / 2 > _.swipeLeft * -1) {
                    swipedSlide = slide;
                    return false;
                }
            });

            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;

            return slidesTraversed;
        } else {
            return _.options.slidesToScroll;
        }
    };

    Slick.prototype.goTo = Slick.prototype.slickGoTo = function (slide, dontAnimate) {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'index',
                index: parseInt(slide)
            }
        }, dontAnimate);
    };

    Slick.prototype.init = function (creation) {

        var _ = this;

        if (!$(_.$slider).hasClass('slick-initialized')) {

            $(_.$slider).addClass('slick-initialized');

            _.buildRows();
            _.buildOut();
            _.setProps();
            _.startLoad();
            _.loadSlider();
            _.initializeEvents();
            _.updateArrows();
            _.updateDots();
            _.checkResponsive(true);
            _.focusHandler();
        }

        if (creation) {
            _.$slider.trigger('init', [_]);
        }

        if (_.options.accessibility === true) {
            _.initADA();
        }

        if (_.options.autoplay) {

            _.paused = false;
            _.autoPlay();
        }
    };

    Slick.prototype.initADA = function () {
        var _ = this;
        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
            'aria-hidden': 'true',
            'tabindex': '-1'
        }).find('a, input, button, select').attr({
            'tabindex': '-1'
        });

        _.$slideTrack.attr('role', 'listbox');

        _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function (i) {
            $(this).attr({
                'role': 'option',
                'aria-describedby': 'slick-slide' + _.instanceUid + i + ''
            });
        });

        if (_.$dots !== null) {
            _.$dots.attr('role', 'tablist').find('li').each(function (i) {
                $(this).attr({
                    'role': 'presentation',
                    'aria-selected': 'false',
                    'aria-controls': 'navigation' + _.instanceUid + i + '',
                    'id': 'slick-slide' + _.instanceUid + i + ''
                });
            }).first().attr('aria-selected', 'true').end().find('button').attr('role', 'button').end().closest('div').attr('role', 'toolbar');
        }
        _.activateADA();
    };

    Slick.prototype.initArrowEvents = function () {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow.off('click.slick').on('click.slick', {
                message: 'previous'
            }, _.changeSlide);
            _.$nextArrow.off('click.slick').on('click.slick', {
                message: 'next'
            }, _.changeSlide);
        }
    };

    Slick.prototype.initDotEvents = function () {

        var _ = this;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            $('li', _.$dots).on('click.slick', {
                message: 'index'
            }, _.changeSlide);
        }

        if (_.options.dots === true && _.options.pauseOnDotsHover === true) {

            $('li', _.$dots).on('mouseenter.slick', $.proxy(_.interrupt, _, true)).on('mouseleave.slick', $.proxy(_.interrupt, _, false));
        }
    };

    Slick.prototype.initSlideEvents = function () {

        var _ = this;

        if (_.options.pauseOnHover) {

            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));
        }
    };

    Slick.prototype.initializeEvents = function () {

        var _ = this;

        _.initArrowEvents();

        _.initDotEvents();
        _.initSlideEvents();

        _.$list.on('touchstart.slick mousedown.slick', {
            action: 'start'
        }, _.swipeHandler);
        _.$list.on('touchmove.slick mousemove.slick', {
            action: 'move'
        }, _.swipeHandler);
        _.$list.on('touchend.slick mouseup.slick', {
            action: 'end'
        }, _.swipeHandler);
        _.$list.on('touchcancel.slick mouseleave.slick', {
            action: 'end'
        }, _.swipeHandler);

        _.$list.on('click.slick', _.clickHandler);

        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));

        if (_.options.accessibility === true) {
            _.$list.on('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));

        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));

        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);

        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
        $(document).on('ready.slick.slick-' + _.instanceUid, _.setPosition);
    };

    Slick.prototype.initUI = function () {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.show();
            _.$nextArrow.show();
        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.show();
        }
    };

    Slick.prototype.keyHandler = function (event) {

        var _ = this;
        //Dont slide if the cursor is inside the form fields and arrow keys are pressed
        if (!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
            if (event.keyCode === 37 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'next' : 'previous'
                    }
                });
            } else if (event.keyCode === 39 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'previous' : 'next'
                    }
                });
            }
        }
    };

    Slick.prototype.lazyLoad = function () {

        var _ = this,
            loadRange,
            cloneRange,
            rangeStart,
            rangeEnd;

        function loadImages(imagesScope) {

            $('img[data-lazy]', imagesScope).each(function () {

                var image = $(this),
                    imageSource = $(this).attr('data-lazy'),
                    imageToLoad = document.createElement('img');

                imageToLoad.onload = function () {

                    image.animate({ opacity: 0 }, 100, function () {
                        image.attr('src', imageSource).animate({ opacity: 1 }, 200, function () {
                            image.removeAttr('data-lazy').removeClass('slick-loading');
                        });
                        _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
                    });
                };

                imageToLoad.onerror = function () {

                    image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');

                    _.$slider.trigger('lazyLoadError', [_, image, imageSource]);
                };

                imageToLoad.src = imageSource;
            });
        }

        if (_.options.centerMode === true) {
            if (_.options.infinite === true) {
                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
                rangeEnd = rangeStart + _.options.slidesToShow + 2;
            } else {
                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
            }
        } else {
            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
            if (_.options.fade === true) {
                if (rangeStart > 0) rangeStart--;
                if (rangeEnd <= _.slideCount) rangeEnd++;
            }
        }

        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);
        loadImages(loadRange);

        if (_.slideCount <= _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-slide');
            loadImages(cloneRange);
        } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
            loadImages(cloneRange);
        } else if (_.currentSlide === 0) {
            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
            loadImages(cloneRange);
        }
    };

    Slick.prototype.loadSlider = function () {

        var _ = this;

        _.setPosition();

        _.$slideTrack.css({
            opacity: 1
        });

        _.$slider.removeClass('slick-loading');

        _.initUI();

        if (_.options.lazyLoad === 'progressive') {
            _.progressiveLazyLoad();
        }
    };

    Slick.prototype.next = Slick.prototype.slickNext = function () {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'next'
            }
        });
    };

    Slick.prototype.orientationChange = function () {

        var _ = this;

        _.checkResponsive();
        _.setPosition();
    };

    Slick.prototype.pause = Slick.prototype.slickPause = function () {

        var _ = this;

        _.autoPlayClear();
        _.paused = true;
    };

    Slick.prototype.play = Slick.prototype.slickPlay = function () {

        var _ = this;

        _.autoPlay();
        _.options.autoplay = true;
        _.paused = false;
        _.focussed = false;
        _.interrupted = false;
    };

    Slick.prototype.postSlide = function (index) {

        var _ = this;

        if (!_.unslicked) {

            _.$slider.trigger('afterChange', [_, index]);

            _.animating = false;

            _.setPosition();

            _.swipeLeft = null;

            if (_.options.autoplay) {
                _.autoPlay();
            }

            if (_.options.accessibility === true) {
                _.initADA();
            }
        }
    };

    Slick.prototype.prev = Slick.prototype.slickPrev = function () {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'previous'
            }
        });
    };

    Slick.prototype.preventDefault = function (event) {

        event.preventDefault();
    };

    Slick.prototype.progressiveLazyLoad = function (tryCount) {

        tryCount = tryCount || 1;

        var _ = this,
            $imgsToLoad = $('img[data-lazy]', _.$slider),
            image,
            imageSource,
            imageToLoad;

        if ($imgsToLoad.length) {

            image = $imgsToLoad.first();
            imageSource = image.attr('data-lazy');
            imageToLoad = document.createElement('img');

            imageToLoad.onload = function () {

                image.attr('src', imageSource).removeAttr('data-lazy').removeClass('slick-loading');

                if (_.options.adaptiveHeight === true) {
                    _.setPosition();
                }

                _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
                _.progressiveLazyLoad();
            };

            imageToLoad.onerror = function () {

                if (tryCount < 3) {

                    /**
                     * try to load the image 3 times,
                     * leave a slight delay so we don't get
                     * servers blocking the request.
                     */
                    setTimeout(function () {
                        _.progressiveLazyLoad(tryCount + 1);
                    }, 500);
                } else {

                    image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');

                    _.$slider.trigger('lazyLoadError', [_, image, imageSource]);

                    _.progressiveLazyLoad();
                }
            };

            imageToLoad.src = imageSource;
        } else {

            _.$slider.trigger('allImagesLoaded', [_]);
        }
    };

    Slick.prototype.refresh = function (initializing) {

        var _ = this,
            currentSlide,
            lastVisibleIndex;

        lastVisibleIndex = _.slideCount - _.options.slidesToShow;

        // in non-infinite sliders, we don't want to go past the
        // last visible index.
        if (!_.options.infinite && _.currentSlide > lastVisibleIndex) {
            _.currentSlide = lastVisibleIndex;
        }

        // if less slides than to show, go to start.
        if (_.slideCount <= _.options.slidesToShow) {
            _.currentSlide = 0;
        }

        currentSlide = _.currentSlide;

        _.destroy(true);

        $.extend(_, _.initials, { currentSlide: currentSlide });

        _.init();

        if (!initializing) {

            _.changeSlide({
                data: {
                    message: 'index',
                    index: currentSlide
                }
            }, false);
        }
    };

    Slick.prototype.registerBreakpoints = function () {

        var _ = this,
            breakpoint,
            currentBreakpoint,
            l,
            responsiveSettings = _.options.responsive || null;

        if ($.type(responsiveSettings) === 'array' && responsiveSettings.length) {

            _.respondTo = _.options.respondTo || 'window';

            for (breakpoint in responsiveSettings) {

                l = _.breakpoints.length - 1;
                currentBreakpoint = responsiveSettings[breakpoint].breakpoint;

                if (responsiveSettings.hasOwnProperty(breakpoint)) {

                    // loop through the breakpoints and cut out any existing
                    // ones with the same breakpoint number, we don't want dupes.
                    while (l >= 0) {
                        if (_.breakpoints[l] && _.breakpoints[l] === currentBreakpoint) {
                            _.breakpoints.splice(l, 1);
                        }
                        l--;
                    }

                    _.breakpoints.push(currentBreakpoint);
                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;
                }
            }

            _.breakpoints.sort(function (a, b) {
                return _.options.mobileFirst ? a - b : b - a;
            });
        }
    };

    Slick.prototype.reinit = function () {

        var _ = this;

        _.$slides = _.$slideTrack.children(_.options.slide).addClass('slick-slide');

        _.slideCount = _.$slides.length;

        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
            _.currentSlide = _.currentSlide - _.options.slidesToScroll;
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.currentSlide = 0;
        }

        _.registerBreakpoints();

        _.setProps();
        _.setupInfinite();
        _.buildArrows();
        _.updateArrows();
        _.initArrowEvents();
        _.buildDots();
        _.updateDots();
        _.initDotEvents();
        _.cleanUpSlideEvents();
        _.initSlideEvents();

        _.checkResponsive(false, true);

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        _.setPosition();
        _.focusHandler();

        _.paused = !_.options.autoplay;
        _.autoPlay();

        _.$slider.trigger('reInit', [_]);
    };

    Slick.prototype.resize = function () {

        var _ = this;

        if ($(window).width() !== _.windowWidth) {
            clearTimeout(_.windowDelay);
            _.windowDelay = window.setTimeout(function () {
                _.windowWidth = $(window).width();
                _.checkResponsive();
                if (!_.unslicked) {
                    _.setPosition();
                }
            }, 50);
        }
    };

    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function (index, removeBefore, removeAll) {

        var _ = this;

        if (typeof index === 'boolean') {
            removeBefore = index;
            index = removeBefore === true ? 0 : _.slideCount - 1;
        } else {
            index = removeBefore === true ? --index : index;
        }

        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
            return false;
        }

        _.unload();

        if (removeAll === true) {
            _.$slideTrack.children().remove();
        } else {
            _.$slideTrack.children(this.options.slide).eq(index).remove();
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slidesCache = _.$slides;

        _.reinit();
    };

    Slick.prototype.setCSS = function (position) {

        var _ = this,
            positionProps = {},
            x,
            y;

        if (_.options.rtl === true) {
            position = -position;
        }
        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';

        positionProps[_.positionProp] = position;

        if (_.transformsEnabled === false) {
            _.$slideTrack.css(positionProps);
        } else {
            positionProps = {};
            if (_.cssTransitions === false) {
                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
                _.$slideTrack.css(positionProps);
            } else {
                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
                _.$slideTrack.css(positionProps);
            }
        }
    };

    Slick.prototype.setDimensions = function () {

        var _ = this;

        if (_.options.vertical === false) {
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: '0px ' + _.options.centerPadding
                });
            }
        } else {
            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: _.options.centerPadding + ' 0px'
                });
            }
        }

        _.listWidth = _.$list.width();
        _.listHeight = _.$list.height();

        if (_.options.vertical === false && _.options.variableWidth === false) {
            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
            _.$slideTrack.width(Math.ceil(_.slideWidth * _.$slideTrack.children('.slick-slide').length));
        } else if (_.options.variableWidth === true) {
            _.$slideTrack.width(5000 * _.slideCount);
        } else {
            _.slideWidth = Math.ceil(_.listWidth);
            _.$slideTrack.height(Math.ceil(_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length));
        }

        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);
    };

    Slick.prototype.setFade = function () {

        var _ = this,
            targetLeft;

        _.$slides.each(function (index, element) {
            targetLeft = _.slideWidth * index * -1;
            if (_.options.rtl === true) {
                $(element).css({
                    position: 'relative',
                    right: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            } else {
                $(element).css({
                    position: 'relative',
                    left: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            }
        });

        _.$slides.eq(_.currentSlide).css({
            zIndex: _.options.zIndex - 1,
            opacity: 1
        });
    };

    Slick.prototype.setHeight = function () {

        var _ = this;

        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.css('height', targetHeight);
        }
    };

    Slick.prototype.setOption = Slick.prototype.slickSetOption = function () {

        /**
         * accepts arguments in format of:
         *
         *  - for changing a single option's value:
         *     .slick("setOption", option, value, refresh )
         *
         *  - for changing a set of responsive options:
         *     .slick("setOption", 'responsive', [{}, ...], refresh )
         *
         *  - for updating multiple values at once (not responsive)
         *     .slick("setOption", { 'option': value, ... }, refresh )
         */

        var _ = this,
            l,
            item,
            option,
            value,
            refresh = false,
            type;

        if ($.type(arguments[0]) === 'object') {

            option = arguments[0];
            refresh = arguments[1];
            type = 'multiple';
        } else if ($.type(arguments[0]) === 'string') {

            option = arguments[0];
            value = arguments[1];
            refresh = arguments[2];

            if (arguments[0] === 'responsive' && $.type(arguments[1]) === 'array') {

                type = 'responsive';
            } else if (typeof arguments[1] !== 'undefined') {

                type = 'single';
            }
        }

        if (type === 'single') {

            _.options[option] = value;
        } else if (type === 'multiple') {

            $.each(option, function (opt, val) {

                _.options[opt] = val;
            });
        } else if (type === 'responsive') {

            for (item in value) {

                if ($.type(_.options.responsive) !== 'array') {

                    _.options.responsive = [value[item]];
                } else {

                    l = _.options.responsive.length - 1;

                    // loop through the responsive object and splice out duplicates.
                    while (l >= 0) {

                        if (_.options.responsive[l].breakpoint === value[item].breakpoint) {

                            _.options.responsive.splice(l, 1);
                        }

                        l--;
                    }

                    _.options.responsive.push(value[item]);
                }
            }
        }

        if (refresh) {

            _.unload();
            _.reinit();
        }
    };

    Slick.prototype.setPosition = function () {

        var _ = this;

        _.setDimensions();

        _.setHeight();

        if (_.options.fade === false) {
            _.setCSS(_.getLeft(_.currentSlide));
        } else {
            _.setFade();
        }

        _.$slider.trigger('setPosition', [_]);
    };

    Slick.prototype.setProps = function () {

        var _ = this,
            bodyStyle = document.body.style;

        _.positionProp = _.options.vertical === true ? 'top' : 'left';

        if (_.positionProp === 'top') {
            _.$slider.addClass('slick-vertical');
        } else {
            _.$slider.removeClass('slick-vertical');
        }

        if (bodyStyle.WebkitTransition !== undefined || bodyStyle.MozTransition !== undefined || bodyStyle.msTransition !== undefined) {
            if (_.options.useCSS === true) {
                _.cssTransitions = true;
            }
        }

        if (_.options.fade) {
            if (typeof _.options.zIndex === 'number') {
                if (_.options.zIndex < 3) {
                    _.options.zIndex = 3;
                }
            } else {
                _.options.zIndex = _.defaults.zIndex;
            }
        }

        if (bodyStyle.OTransform !== undefined) {
            _.animType = 'OTransform';
            _.transformType = '-o-transform';
            _.transitionType = 'OTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.MozTransform !== undefined) {
            _.animType = 'MozTransform';
            _.transformType = '-moz-transform';
            _.transitionType = 'MozTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.webkitTransform !== undefined) {
            _.animType = 'webkitTransform';
            _.transformType = '-webkit-transform';
            _.transitionType = 'webkitTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.msTransform !== undefined) {
            _.animType = 'msTransform';
            _.transformType = '-ms-transform';
            _.transitionType = 'msTransition';
            if (bodyStyle.msTransform === undefined) _.animType = false;
        }
        if (bodyStyle.transform !== undefined && _.animType !== false) {
            _.animType = 'transform';
            _.transformType = 'transform';
            _.transitionType = 'transition';
        }
        _.transformsEnabled = _.options.useTransform && _.animType !== null && _.animType !== false;
    };

    Slick.prototype.setSlideClasses = function (index) {

        var _ = this,
            centerOffset,
            allSlides,
            indexOffset,
            remainder;

        allSlides = _.$slider.find('.slick-slide').removeClass('slick-active slick-center slick-current').attr('aria-hidden', 'true');

        _.$slides.eq(index).addClass('slick-current');

        if (_.options.centerMode === true) {

            centerOffset = Math.floor(_.options.slidesToShow / 2);

            if (_.options.infinite === true) {

                if (index >= centerOffset && index <= _.slideCount - 1 - centerOffset) {

                    _.$slides.slice(index - centerOffset, index + centerOffset + 1).addClass('slick-active').attr('aria-hidden', 'false');
                } else {

                    indexOffset = _.options.slidesToShow + index;
                    allSlides.slice(indexOffset - centerOffset + 1, indexOffset + centerOffset + 2).addClass('slick-active').attr('aria-hidden', 'false');
                }

                if (index === 0) {

                    allSlides.eq(allSlides.length - 1 - _.options.slidesToShow).addClass('slick-center');
                } else if (index === _.slideCount - 1) {

                    allSlides.eq(_.options.slidesToShow).addClass('slick-center');
                }
            }

            _.$slides.eq(index).addClass('slick-center');
        } else {

            if (index >= 0 && index <= _.slideCount - _.options.slidesToShow) {

                _.$slides.slice(index, index + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
            } else if (allSlides.length <= _.options.slidesToShow) {

                allSlides.addClass('slick-active').attr('aria-hidden', 'false');
            } else {

                remainder = _.slideCount % _.options.slidesToShow;
                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;

                if (_.options.slidesToShow == _.options.slidesToScroll && _.slideCount - index < _.options.slidesToShow) {

                    allSlides.slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder).addClass('slick-active').attr('aria-hidden', 'false');
                } else {

                    allSlides.slice(indexOffset, indexOffset + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
                }
            }
        }

        if (_.options.lazyLoad === 'ondemand') {
            _.lazyLoad();
        }
    };

    Slick.prototype.setupInfinite = function () {

        var _ = this,
            i,
            slideIndex,
            infiniteCount;

        if (_.options.fade === true) {
            _.options.centerMode = false;
        }

        if (_.options.infinite === true && _.options.fade === false) {

            slideIndex = null;

            if (_.slideCount > _.options.slidesToShow) {

                if (_.options.centerMode === true) {
                    infiniteCount = _.options.slidesToShow + 1;
                } else {
                    infiniteCount = _.options.slidesToShow;
                }

                for (i = _.slideCount; i > _.slideCount - infiniteCount; i -= 1) {
                    slideIndex = i - 1;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '').attr('data-slick-index', slideIndex - _.slideCount).prependTo(_.$slideTrack).addClass('slick-cloned');
                }
                for (i = 0; i < infiniteCount; i += 1) {
                    slideIndex = i;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '').attr('data-slick-index', slideIndex + _.slideCount).appendTo(_.$slideTrack).addClass('slick-cloned');
                }
                _.$slideTrack.find('.slick-cloned').find('[id]').each(function () {
                    $(this).attr('id', '');
                });
            }
        }
    };

    Slick.prototype.interrupt = function (toggle) {

        var _ = this;

        if (!toggle) {
            _.autoPlay();
        }
        _.interrupted = toggle;
    };

    Slick.prototype.selectHandler = function (event) {

        var _ = this;

        var targetElement = $(event.target).is('.slick-slide') ? $(event.target) : $(event.target).parents('.slick-slide');

        var index = parseInt(targetElement.attr('data-slick-index'));

        if (!index) index = 0;

        if (_.slideCount <= _.options.slidesToShow) {

            _.setSlideClasses(index);
            _.asNavFor(index);
            return;
        }

        _.slideHandler(index);
    };

    Slick.prototype.slideHandler = function (index, sync, dontAnimate) {

        var targetSlide,
            animSlide,
            oldSlide,
            slideLeft,
            targetLeft = null,
            _ = this,
            navTarget;

        sync = sync || false;

        if (_.animating === true && _.options.waitForAnimate === true) {
            return;
        }

        if (_.options.fade === true && _.currentSlide === index) {
            return;
        }

        if (_.slideCount <= _.options.slidesToShow) {
            return;
        }

        if (sync === false) {
            _.asNavFor(index);
        }

        targetSlide = index;
        targetLeft = _.getLeft(targetSlide);
        slideLeft = _.getLeft(_.currentSlide);

        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;

        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true) {
                    _.animateSlide(slideLeft, function () {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > _.slideCount - _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true) {
                    _.animateSlide(slideLeft, function () {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        }

        if (_.options.autoplay) {
            clearInterval(_.autoPlayTimer);
        }

        if (targetSlide < 0) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = _.slideCount - _.slideCount % _.options.slidesToScroll;
            } else {
                animSlide = _.slideCount + targetSlide;
            }
        } else if (targetSlide >= _.slideCount) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = 0;
            } else {
                animSlide = targetSlide - _.slideCount;
            }
        } else {
            animSlide = targetSlide;
        }

        _.animating = true;

        _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);

        oldSlide = _.currentSlide;
        _.currentSlide = animSlide;

        _.setSlideClasses(_.currentSlide);

        if (_.options.asNavFor) {

            navTarget = _.getNavTarget();
            navTarget = navTarget.slick('getSlick');

            if (navTarget.slideCount <= navTarget.options.slidesToShow) {
                navTarget.setSlideClasses(_.currentSlide);
            }
        }

        _.updateDots();
        _.updateArrows();

        if (_.options.fade === true) {
            if (dontAnimate !== true) {

                _.fadeSlideOut(oldSlide);

                _.fadeSlide(animSlide, function () {
                    _.postSlide(animSlide);
                });
            } else {
                _.postSlide(animSlide);
            }
            _.animateHeight();
            return;
        }

        if (dontAnimate !== true) {
            _.animateSlide(targetLeft, function () {
                _.postSlide(animSlide);
            });
        } else {
            _.postSlide(animSlide);
        }
    };

    Slick.prototype.startLoad = function () {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.hide();
            _.$nextArrow.hide();
        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.hide();
        }

        _.$slider.addClass('slick-loading');
    };

    Slick.prototype.swipeDirection = function () {

        var xDist,
            yDist,
            r,
            swipeAngle,
            _ = this;

        xDist = _.touchObject.startX - _.touchObject.curX;
        yDist = _.touchObject.startY - _.touchObject.curY;
        r = Math.atan2(yDist, xDist);

        swipeAngle = Math.round(r * 180 / Math.PI);
        if (swipeAngle < 0) {
            swipeAngle = 360 - Math.abs(swipeAngle);
        }

        if (swipeAngle <= 45 && swipeAngle >= 0) {
            return _.options.rtl === false ? 'left' : 'right';
        }
        if (swipeAngle <= 360 && swipeAngle >= 315) {
            return _.options.rtl === false ? 'left' : 'right';
        }
        if (swipeAngle >= 135 && swipeAngle <= 225) {
            return _.options.rtl === false ? 'right' : 'left';
        }
        if (_.options.verticalSwiping === true) {
            if (swipeAngle >= 35 && swipeAngle <= 135) {
                return 'down';
            } else {
                return 'up';
            }
        }

        return 'vertical';
    };

    Slick.prototype.swipeEnd = function (event) {

        var _ = this,
            slideCount,
            direction;

        _.dragging = false;
        _.interrupted = false;
        _.shouldClick = _.touchObject.swipeLength > 10 ? false : true;

        if (_.touchObject.curX === undefined) {
            return false;
        }

        if (_.touchObject.edgeHit === true) {
            _.$slider.trigger('edge', [_, _.swipeDirection()]);
        }

        if (_.touchObject.swipeLength >= _.touchObject.minSwipe) {

            direction = _.swipeDirection();

            switch (direction) {

                case 'left':
                case 'down':

                    slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide + _.getSlideCount()) : _.currentSlide + _.getSlideCount();

                    _.currentDirection = 0;

                    break;

                case 'right':
                case 'up':

                    slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide - _.getSlideCount()) : _.currentSlide - _.getSlideCount();

                    _.currentDirection = 1;

                    break;

                default:

            }

            if (direction != 'vertical') {

                _.slideHandler(slideCount);
                _.touchObject = {};
                _.$slider.trigger('swipe', [_, direction]);
            }
        } else {

            if (_.touchObject.startX !== _.touchObject.curX) {

                _.slideHandler(_.currentSlide);
                _.touchObject = {};
            }
        }
    };

    Slick.prototype.swipeHandler = function (event) {

        var _ = this;

        if (_.options.swipe === false || 'ontouchend' in document && _.options.swipe === false) {
            return;
        } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
            return;
        }

        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ? event.originalEvent.touches.length : 1;

        _.touchObject.minSwipe = _.listWidth / _.options.touchThreshold;

        if (_.options.verticalSwiping === true) {
            _.touchObject.minSwipe = _.listHeight / _.options.touchThreshold;
        }

        switch (event.data.action) {

            case 'start':
                _.swipeStart(event);
                break;

            case 'move':
                _.swipeMove(event);
                break;

            case 'end':
                _.swipeEnd(event);
                break;

        }
    };

    Slick.prototype.swipeMove = function (event) {

        var _ = this,
            edgeWasHit = false,
            curLeft,
            swipeDirection,
            swipeLength,
            positionOffset,
            touches;

        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;

        if (!_.dragging || touches && touches.length !== 1) {
            return false;
        }

        curLeft = _.getLeft(_.currentSlide);

        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;

        _.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));

        if (_.options.verticalSwiping === true) {
            _.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));
        }

        swipeDirection = _.swipeDirection();

        if (swipeDirection === 'vertical') {
            return;
        }

        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
            event.preventDefault();
        }

        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
        if (_.options.verticalSwiping === true) {
            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
        }

        swipeLength = _.touchObject.swipeLength;

        _.touchObject.edgeHit = false;

        if (_.options.infinite === false) {
            if (_.currentSlide === 0 && swipeDirection === 'right' || _.currentSlide >= _.getDotCount() && swipeDirection === 'left') {
                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
                _.touchObject.edgeHit = true;
            }
        }

        if (_.options.vertical === false) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        } else {
            _.swipeLeft = curLeft + swipeLength * (_.$list.height() / _.listWidth) * positionOffset;
        }
        if (_.options.verticalSwiping === true) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        }

        if (_.options.fade === true || _.options.touchMove === false) {
            return false;
        }

        if (_.animating === true) {
            _.swipeLeft = null;
            return false;
        }

        _.setCSS(_.swipeLeft);
    };

    Slick.prototype.swipeStart = function (event) {

        var _ = this,
            touches;

        _.interrupted = true;

        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
            _.touchObject = {};
            return false;
        }

        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
            touches = event.originalEvent.touches[0];
        }

        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;

        _.dragging = true;
    };

    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function () {

        var _ = this;

        if (_.$slidesCache !== null) {

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.appendTo(_.$slideTrack);

            _.reinit();
        }
    };

    Slick.prototype.unload = function () {

        var _ = this;

        $('.slick-cloned', _.$slider).remove();

        if (_.$dots) {
            _.$dots.remove();
        }

        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
            _.$prevArrow.remove();
        }

        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
            _.$nextArrow.remove();
        }

        _.$slides.removeClass('slick-slide slick-active slick-visible slick-current').attr('aria-hidden', 'true').css('width', '');
    };

    Slick.prototype.unslick = function (fromBreakpoint) {

        var _ = this;
        _.$slider.trigger('unslick', [_, fromBreakpoint]);
        _.destroy();
    };

    Slick.prototype.updateArrows = function () {

        var _ = this,
            centerOffset;

        centerOffset = Math.floor(_.options.slidesToShow / 2);

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow && !_.options.infinite) {

            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            if (_.currentSlide === 0) {

                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            }
        }
    };

    Slick.prototype.updateDots = function () {

        var _ = this;

        if (_.$dots !== null) {

            _.$dots.find('li').removeClass('slick-active').attr('aria-hidden', 'true');

            _.$dots.find('li').eq(Math.floor(_.currentSlide / _.options.slidesToScroll)).addClass('slick-active').attr('aria-hidden', 'false');
        }
    };

    Slick.prototype.visibility = function () {

        var _ = this;

        if (_.options.autoplay) {

            if (document[_.hidden]) {

                _.interrupted = true;
            } else {

                _.interrupted = false;
            }
        }
    };

    $.fn.slick = function () {
        var _ = this,
            opt = arguments[0],
            args = Array.prototype.slice.call(arguments, 1),
            l = _.length,
            i,
            ret;
        for (i = 0; i < l; i++) {
            if ((typeof opt === 'undefined' ? 'undefined' : _typeof(opt)) == 'object' || typeof opt == 'undefined') _[i].slick = new Slick(_[i], opt);else ret = _[i].slick[opt].apply(_[i].slick, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    };

    // Careers Page slider
    // CSS located on _slider.scss
    $('.gallery br').remove();
    console.log('.gallery br Removed | Run Slick');
    $('.gallery').slick({
        dots: true,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 4000,
        pauseOnHover: true,
        nextArrow: '<button class="control_next">></button>',
        prevArrow: '<button class="control_prev"><</button>'
    });
});
 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

'use strict';

/**
* This file is loaded asyncronously in the footer.
* All custom global scripts should be included here.
*/
window.addEventListener('load', function () {
	'use strict';

	// Load event function ... most custom stuff goes here. Safer for async.

	jQuery(window).on('load', function () {
		var searchForm = jQuery('#search-form');
		var searchInput = jQuery('#search-input');
		searchForm.click(function (e) {
			if (jQuery(event.target).hasClass('search-form__button') && searchInput.val() === "") {
				searchInput.focus();
				//	search.toggleClass( 'search-form--active' );
				event.preventDefault();
			} else {
				searchInput.focus();
				//	searchForm.addClass( 'search-form--active' );
			}
		});

		searchInput.focusout(function (event) {
			if (searchInput.val() === "") {
				//	searchForm.removeClass( 'search-form--active' );
			}
		});

		searchInput.keyup(function (event) {
			if (event.keyCode == 13) {
				searchForm.submit();
				return false;
			}
		});

		// search child dom elements for a[href], and follow that on click events 2015-11-03
		jQuery(".linkclicker").click(function (e) {
			e.preventDefault();
			if (jQuery(this).find("a:first").attr("target")) {
				// new tab
				window.open(jQuery(this).find("a:first").attr("href"));
			} else {
				// same tab
				window.location = jQuery(this).find("a:first").attr("href");
			}
		});

		// 2016-05-15, force opening external links in new tab.
		if (!jQuery('a').attr('target')) {
			jQuery('a[href^=http]:not([href*="' + dbs.http_host + '"])').attr('target', '_blank').attr('rel', 'noopener');
		}

		// Enable default resize to parent function
		jQuery('.dont-resize-img').resizeToParent({ parent: '.resize-parent' });
	});

	// Adding superscript <sup> tags around all trademark and registered trademark symbols
	jQuery('body :not(script,sup)').contents().filter(function () {
		return this.nodeType === 3;
	}).replaceWith(function () {
		return this.nodeValue.replace(/[™®©]/g, '<sup>$&</sup>');
	});

	// Mobile search bar click functionality
	jQuery('.main-secondary-menu__item.search-form-menu__item').on('click', function () {
		if (jQuery(this).hasClass('open')) {
			jQuery(this).removeClass('open');
			jQuery(".site-mobile-overlay").removeClass("open");
			jQuery(this).focus();
		} else {
			jQuery(this).addClass('open');
			jQuery(this).find('#search-input').focus();
			jQuery(".site-mobile-ov Ferlay").addClass("open");
			if ($("#main-menu-toggle").hasClass("open")) {
				$("#main-menu-toggle").removeClass("open");
				$(".main-menu").removeClass("open");
				$(".main-menu > ul[role='menu']").removeClass("open");
			}
		}
	});
	jQuery('.main-secondary-menu__item.search-form-menu__item form').on('click', function (e) {
		e.stopPropagation();
	});
	jQuery('.main-secondary-menu__item.search-form-menu__item').on('click', function (e) {
		e.stopPropagation();
	});
	jQuery(window).on('click', function () {
		if (jQuery('.main-secondary-menu__item.search-form-menu__item').hasClass('open')) {
			jQuery('.main-secondary-menu__item.search-form-menu__item').removeClass('open');
			jQuery(".site-mobile-overlay").removeClass("open");
			jQuery('.main-secondary-menu__item.search-form-menu__item').focus();
		}
	});

	// Sticky Sidebar for Product Pages.
	var sidebarHeight = 0;
	jQuery(window).on('load resize', function () {
		sidebarHeight = jQuery('#single-product__sidebar').outerHeight();
	});

	function getScrollTop() {
		if (typeof pageYOffset != 'undefined') {
			//most browsers except IE before #9
			return pageYOffset;
		} else {
			var B = document.body; //IE 'quirks'
			var D = document.documentElement; //IE with doctype
			D = D.clientHeight ? D : B;
			return D.scrollTop;
		}
	}
	if (jQuery('#single-product__sidebar').length) {
		var closeBox = function closeBox() {
			// This function controls the closing of the lightbox
			$(".backDrop, .box").animate({ "opacity": "0" }, 500);
			$(".backDrop, .close-lightbox, .box").css("display", "none");
		};

		// Code injects name of product into the ctas on single produce pages
		var productNames = document.getElementsByClassName("insert-product-name");
		var productNamesOriginal = document.getElementsByClassName("single-product_head");
		productNamesOriginal = productNamesOriginal[0].innerHTML;
		var productNamesCount;
		for (productNamesCount = 0; productNamesCount < productNames.length; productNamesCount++) {
			productNames[productNamesCount].innerHTML = productNamesOriginal;
		}

		jQuery(window).scroll(function () {
			var grades_content = jQuery('.single-product__grades').offset().top;
			var hr = jQuery('#single-product_hr-top').offset().top;
			var scrollTop = jQuery(window).scrollTop();
			var scrollTop = getScrollTop();
			var sidebar = jQuery('#single-product__sidebar');

			var sidebarOffset = sidebar.offset().top;
			var windowHeight = $(window).height();
			if (sidebar.length > 0 && jQuery(window).width() > 767 && jQuery(window).width() < 1068 && sidebarHeight < windowHeight) {
				// THIS FUNCTIONALITY IS INTENTED ONLY TO FIRE AT THE SPECIFIC SCREEN-SIZE RANGE FOUND IN THE "IF" STATEMENT
				if (grades_content - scrollTop <= sidebarHeight + 60) {
					// THIS STOPS THE SIDEBAR FROM BEING FIXED AT THE BOTTOM OF THE PAGE
					sidebar.removeClass('fix-sidebar');
					sidebar.addClass('sidebar-bottom');
					/* THROUGHOUT THIS FUNCTION, I AM WRITING AND OVERRIDING CSS
     TO BETTER CONTROL WHAT CSS IS APPLIED WHEN. I WILL LABEL THEM CSS OVERRIDES. */
					sidebar.css('top', 'initial');
				} else {
					// THIS IS THE INITIAL 'FIXING' OF THE SIDEBAR
					if (sidebarOffset > hr && hr < scrollTop) {
						sidebar.addClass('fix-sidebar');
						// CSS OVERRIDES
						sidebar.css('top', 20);
					} else {
						sidebar.removeClass('fix-sidebar');
					}
					sidebar.removeClass('sidebar-bottom');
				}
			} else if (sidebar.length > 0 && jQuery(window).width() >= 1068 && sidebarHeight < windowHeight) {
				// THIS FUNCTIONALITY IS INTENTED TO FIRE AT OR ABOVE THE SCREEN WIDTH FOUND IN THE "IF" STATEMENT
				var footer = jQuery('body').outerHeight() - jQuery('.site-footer').outerHeight();
				if (footer - scrollTop - sidebarHeight <= 200) {
					var differenceFromBottom = $('.single-product__data').outerHeight() - sidebarHeight - 180;
					sidebar.css('top', differenceFromBottom);
					sidebar.removeClass('fix-sidebar');
					sidebar.addClass('sidebar-bottom');
				} else {
					// THIS IS THE INITIAL 'FIXING' OF THE SIDEBAR
					if (footer - scrollTop - sidebarHeight > 200 && sidebarOffset > hr && hr < scrollTop) {
						sidebar.addClass('fix-sidebar');
						// CSS OVERRIDES
						sidebar.css('top', 20);
					} else {
						sidebar.removeClass('fix-sidebar');
					}
					sidebar.removeClass('sidebar-bottom');
				}
			} else {
				sidebar.removeClass('sidebar-bottom');
				sidebar.removeClass('fix-sidebar');
			}

			// ADDS THE CONDITION THAT THE ENTIRE SIDEBAR MUST BE VISIBLE TO ENABLE THE STICKY SIDEBAR

			// Highlights relevant sidebar item when element is scrolled into view
			$('.attribute_title, .applications_title').each(function () {
				var half_height = $(window).height() / 2;
				if ($(window).scrollTop() >= $(this).offset().top - half_height) {
					var id = $(this).attr('id');
					if ($('.single-product__sidebar a[href="#' + id + '"]')) {
						$('.single-product__sidebar a.in-view-color:not([href="#' + id + '"]').removeClass('in-view-color');
						$('.single-product__sidebar a[href="#' + id + '"]').addClass('in-view-color');
					}
				}
			});
		});

		// Scroll slower when back to top button clicked on single product pages
		$('.back_to_top').on('click', function () {
			$('html, body').animate({ scrollTop: "0px" }, 500);
		});

		/**
   * Shows the cta when appropriate
   */
		(function () {
			var floating_cta = jQuery('#floating-cta');

			if (floating_cta.length === 0) {
				return; /// There is no floating cta on this page.
			}

			// Flag to see if the cta is visible, this helps to prevent excessive cpu processing
			var floating_cta_is_visible = false;

			// Keep track of the visible range (top and bottom)
			var visible_top = 0;
			if (jQuery('.single-product__data').length !== 0) {
				visible_top = jQuery('.single-product__data').first().offset().top;
			}

			var visible_bottom = window.scrollY - window.innerHeight;
			if (jQuery('.bottom-of-page--cta').length !== 0) {
				visible_bottom = jQuery('.bottom-of-page--cta').first().offset().top - window.innerHeight;
			}

			// On debounceScroll, see if we need to show or hide the cta
			window.addEventListener('debounceScroll', function () {
				var scroll_top = jQuery(window).scrollTop();

				if (floating_cta_is_visible && (visible_top > scroll_top || scroll_top > visible_bottom)) {
					floating_cta.removeClass('show');
					floating_cta_is_visible = false;
				} else if (!floating_cta_is_visible && visible_top < scroll_top && scroll_top < visible_bottom) {
					floating_cta.addClass('show');
					floating_cta_is_visible = true;
				}
			});

			// Every time the window is loaded or resized, update the top and bottom ranges
			jQuery(window).on('load resize', function () {
				// Added conditionals to ensure that the elements exist before checking their offset to prevent errors - JG 1/28/19
				if (jQuery('.single-product__data').length) {
					visible_top = jQuery('.single-product__data').first().offset().top;
				}

				if (jQuery('.bottom-of-page--cta').length) {
					visible_bottom = jQuery('.bottom-of-page--cta').first().offset().top - window.innerHeight;
				}
			});
		})();
		//////////////////////////////////////////////////////////////////////////


		// Lightbox for product pages
		$('.single-product__content img').not('a img').on('click', function (e) {
			// This function controls the opening of the lightbox
			e.preventDefault();
			$('.box').animate({ 'opacity': '1.0' }, 500);
			$(".backDrop").animate({ "opacity": ".70" }, 500);
			$(".backDrop, .close-lightbox, .box").css("display", "block");
			var largeImage = $(this).attr("src");
			$(".largeImage").attr({ src: largeImage });
		});

		;
		// Closes the lightbox on click
		$(".close-lightbox, .backDrop").on("click", function () {
			closeBox();
		});
	}

	// ADDS CLASS THAT CONTROLS THE COLLAPSE/EXPAND FUNCTIONALITY OF THE GRADE TABLES.
	$('.grades_title').each(function () {
		$(this).on('click', function () {
			$(this).toggleClass('expand');
		});
	});

	// ADDS CLASS THAT CONTROLS THE COLLAPSE/EXPAND FUNCTIONALITY OF THE NEWS PAGE.
	$('.press-releases__collapsable h3').each(function () {
		$(this).on('click', function () {
			$(this).toggleClass('content-expanded');

			if ($(this).hasClass('content-expanded')) {
				$('.content-expanded').next().addClass('expand');
			} else {
				$(this).next('.press-releases__content').removeClass('expand');
			}
		});
	});

	// THE INTIAL STATE OF THIS VARIABLE IS AN OPACTICY OF 0. ON SCROLL, THE OPACITCY WILL BE ALTERED
	var pageTop = $('html').offset().top;
	var windowScrollTop = jQuery(window).scrollTop() + jQuery(window).outerHeight();

	var siteHeight = jQuery('.site').outerHeight();
	var siteFooterHeight = jQuery('.site-footer').outerHeight();
	var backToTopLink = jQuery('.back_to_top');
	backToTopLink.addClass('back_to_top--still');

	jQuery(window).on('load resize', function () {
		if (jQuery(document).width() >= 768) {
			siteHeight = jQuery(document).outerHeight();
			siteFooterHeight = jQuery('.site-footer').outerHeight();
			jQuery(window).scroll(function () {
				// windowScrollTop = jQuery( window ).scrollTop() + jQuery( window ).outerHeight();
				if (windowScrollTop > 300) {
					backToTopLink.removeClass('back_to_top--still');
				}

				if (windowScrollTop - 128 >= siteHeight - siteFooterHeight) {
					backToTopLink.css({ 'position': 'absolute', 'right': '0', 'bottom': '0', 'transition': 'unset' });
				} else if (windowScrollTop - 128 <= siteHeight - siteFooterHeight) {
					backToTopLink.css({ 'position': 'fixed', 'right': '0', 'bottom': '173px' });
				}
			});
		} else {
			// backToTopLink.removeClass( 'back_to_top--scrolling' );
			jQuery(window).scroll(function () {
				backToTopLink.addClass('back_to_top--scrolling');
				backToTopLink.removeClass('back_to_top--still');
			});
			// Sticky back to top button
			backToTopLink.css({ 'position': 'fixed', 'right': '0', 'bottom': '0', 'transition': 'unset' });
		}
	});

	// Scroll slower down when above continue button is clicked
	$('.fp-continue-button').on('click', function () {
		$('html, body').animate({ scrollTop: $('.site-header').outerHeight() + $('.home .jumbotron-container').outerHeight() }, 500);
	});

	// Locations Map
	if ($('.layout-responsive-locations-map').length > 0) {
		$('body').addClass('map-page');
	}
	// UI Darkening on Location Point Hovering
	$('.location-info-point__positioner').on('mouseover', function () {
		$('.location-info-point__positioner').removeClass('open');
		$(this).addClass('open');
	});
	$('.location-info-point__positioner').on('mouseleave', function () {
		$(this).removeClass('open');
	});
	$('.location-info-point__positioner').on('mouseover', function () {
		$('.map-page').addClass('darken-ui');
	});
	$('.info-point__container').on('mouseleave', function () {
		$('.map-page').removeClass('darken-ui');
	});
	$('.location-info-point__positioner').on('mouseleave', function () {
		$('.map-page').removeClass('darken-ui');
	});

	$('.map-page .site-content').on('mouseleave', function () {
		$('.map-page').removeClass('darken-ui');
		$('.location-info-point__positioner').removeClass('open');
	});

	// Locations Map menu
	$('.info-point__menu-item:first-of-type').on('mouseover', function (e) {
		$('.location-info-point__positioner:first-of-type').trigger(e.type);
	});
	$('.info-point__menu-item:nth-child(2)').on('mouseover', function (e) {
		$('.location-info-point__positioner:nth-child(2)').trigger(e.type);
	});
	$('.info-point__menu-item:nth-child(3)').on('mouseover', function (e) {
		$('.location-info-point__positioner:nth-child(3)').trigger(e.type);
	});
	$('.info-point__menu-item:nth-child(4)').on('mouseover', function (e) {
		$('.location-info-point__positioner:nth-child(4)').trigger(e.type);
	});
	$('.info-point__menu-item:nth-child(5)').on('mouseover', function (e) {
		$('.location-info-point__positioner:nth-child(5)').trigger(e.type);
	});
	$('.info-point__menu-item:nth-child(6)').on('mouseover', function (e) {
		$('.location-info-point__positioner:nth-child(6)').trigger(e.type);
	});
	$('.info-point__menu-item:nth-child(7)').on('mouseover', function (e) {
		$('.location-info-point__positioner:nth-child(7)').trigger(e.type);
	});
	$('.info-point__menu-item:last-of-type').on('mouseover', function (e) {
		$('.location-info-point__positioner:last-of-type').trigger(e.type);
	});

	$('table.nipol a:not([href*=""])').each(function () {
		var builtURL = '/wp-content/uploads/nipol-' + $(this).text() + '.pdf';
		$(this).attr('href', builtURL);
	});
	$('table.hydrin a:not([href*=""])').each(function () {
		var builtURL = '/wp-content/uploads/hydrin-' + $(this).text() + '.pdf';
		$(this).attr('href', builtURL);
	});
	$('table.chemisat a:not([href*=""])').each(function () {
		var builtURL = '/wp-content/uploads/chemisat-' + $(this).text() + '.pdf';
		$(this).attr('href', builtURL);
	});
	$('table.hytemp a:not([href*=""])').each(function () {
		var builtURL = '/wp-content/uploads/hytemp-' + $(this).text() + '.pdf';
		$(this).attr('href', builtURL);
	});
	$('table.zeoforte a:not([href*=""])').each(function () {
		var builtURL = '/wp-content/uploads/zeoforte-' + $(this).text() + '.pdf';
		$(this).attr('href', builtURL);
	});

	//COULD BE BETTER
	var gradeLinks = ['chemisat-lch-7302x.pdf', 'hydrin-c2000.pdf', 'hydrin-c2000.pdf', 'hydrin-c2000l.pdf', 'hydrin-c2000l.pdf', 'hydrin-c2000ll.pdf', 'hydrin-c2000ll.pdf', 'hydrin-c2000m.pdf', 'hydrin-c2000m.pdf', 'hydrin-c2000xl.pdf', 'hydrin-c2000xl.pdf', 'hydrin-h1100.pdf', 'hydrin-h1100.pdf', 'hydrin-h45.pdf', 'hydrin-h45.pdf', 'hydrin-h55.pdf', 'hydrin-h55.pdf', 'hydrin-h65.pdf', 'hydrin-h65.pdf', 'hydrin-px.pdf', 'hydrin-t3000.pdf', 'hydrin-t3000.pdf', 'hydrin-t3000l.pdf', 'hydrin-t3000l.pdf', 'hydrin-t3000ll.pdf', 'hydrin-t3000ll.pdf', 'hydrin-t3100.pdf', 'hydrin-t3100.pdf', 'hydrin-t3102.pdf', 'hydrin-t3102.pdf', 'hydrin-t3105.pdf', 'hydrin-t3105.pdf', 'hydrin-t3105b.pdf', 'hydrin-t3105b.pdf', 'hydrin-t3106.pdf', 'hydrin-t3106.pdf', 'hydrin-t3108.pdf', 'hydrin-t3108.pdf', 'hydrin-t3108xl.pdf', 'hydrin-t3108xl.pdf', 'hydrin-t5010.pdf', 'hydrin-t5010.pdf', 'hytemp-4051cg.pdf', 'hytemp-4051ep.pdf', 'hytemp-4052ep.pdf', 'hytemp-4053ep.pdf', 'hytemp-4054.pdf', 'hytemp-4065.pdf', 'hytemp-4451cg.pdf', 'hytemp-4454.pdf', 'hytemp-ar12.pdf', 'hytemp-ar12b.pdf', 'hytemp-ar14.pdf', 'hytemp-ar212hr.pdf', 'hytemp-ar212xp.pdf', 'hytemp-ar214.pdf', 'hytemp-ar22.pdf', 'hytemp-ar71.pdf', 'hytemp-ar715.pdf', 'hytemp-ar71l.pdf', 'hytemp-ar72lf.pdf', 'hytemp-ar74.pdf', 'hytemp-h570.pdf', 'hytemp-hr200.pdf', 'hytemp-npc50.pdf', 'hytemp-ns70.pdf', 'hytemp-pv04.pdf', 'hytemp-sc75.pdf', 'hytemp-sr50.pdf', 'nipol-1000x132.pdf', 'nipol-1001cg.pdf', 'nipol-1001lg.pdf', 'nipol-1002.pdf', 'nipol-1014.pdf', 'nipol-1022x59.pdf', 'nipol-1031.pdf', 'nipol-1032-45.pdf', 'nipol-1032j.pdf', 'nipol-1034-60.pdf', 'nipol-1041.pdf', 'nipol-1041l.pdf', 'nipol-1042.pdf', 'nipol-1043.pdf', 'nipol-1051.pdf', 'nipol-1052.pdf', 'nipol-1052j.pdf', 'nipol-1053.pdf', 'nipol-1072.pdf', 'nipol-1072cgj.pdf', 'nipol-1072cgx.pdf', 'nipol-1072x28.pdf', 'nipol-1082v.pdf', 'nipol-1092-80.pdf', 'nipol-1094-80.pdf', 'nipol-1203w.pdf', 'nipol-1312.pdf', 'nipol-1312lv.pdf', 'nipol-1401lg.pdf', 'nipol-1411.pdf', 'nipol-1411c.pdf', 'nipol-1442.pdf', 'nipol-1472x.pdf', 'nipol-3640s.pdf', 'nipol-4040s.pdf', 'nipol-dn003.pdf', 'nipol-dn1201.pdf', 'nipol-dn1201l.pdf', 'nipol-dn171.pdf', 'nipol-dn202.pdf', 'nipol-dn214.pdf', 'nipol-dn219.pdf', 'nipol-dn2850.pdf', 'nipol-dn2880.pdf', 'nipol-dn302.pdf', 'nipol-dn302h.pdf', 'nipol-dn3335.pdf', 'nipol-dn3350.pdf', 'nipol-dn3380.pdf', 'nipol-dn3635.pdf', 'nipol-dn3650.pdf', 'nipol-dn401l.pdf', 'nipol-dn401ll.pdf', 'nipol-dn4050.pdf', 'nipol-dn4080.pdf', 'nipol-dn4555.pdf', 'nipol-dn4555a.pdf', 'nipol-dn4580.pdf', 'nipol-dn508scr.pdf', 'nipol-n917.pdf', 'nipol-ns116r.pdf', 'nipol-ns612.pdf', 'nipol-ns616.pdf', 'nipol-ns460.pdf', 'nipol-ns522.pdf', 'nipol-nx775.pdf', 'sivic-z2710.pdf', 'sivic-z530.pdf', 'sivic-z620.pdf', 'sivic-z700px.pdf', 'sivic-z702.pdf', 'sivic-z711.pdf', 'sivic-z711lv.pdf', 'sivic-z730.pdf', 'sivic-z730m60.pdf', 'sivic-z740.pdf', 'sivic-z760.pdf', 'zealloy-1422.pdf', 'zealloy-1422x14.pdf', 'zeoforte-zsc-2095cx.pdf', 'zeoforte-zsc-2095cx.pdf', 'zeoforte-zsc-2195cx.pdf', 'zeoforte-zsc-2195cx.pdf', 'zeoforte-zsc-2195h.pdf', 'zeoforte-zsc-2195h.pdf', 'zeoforte-zsc-2195lcx.pdf', 'zeoforte-zsc-2195lcx.pdf', 'zeoforte-zsc-2295cx.pdf', 'zeoforte-zsc-2295cx.pdf', 'zeoforte-zsc-2295l.pdf', 'zeoforte-zsc-2295l.pdf', 'zeoforte-zsc-2395.pdf', 'zetpol-1000l.pdf', 'zetpol-1010.pdf', 'zetpol-1010ep.pdf', 'zetpol-1020.pdf', 'zetpol-2000.pdf', 'zetpol-2000l.pdf', 'zetpol-2001.pdf', 'zetpol-2001ep.pdf', 'zetpol-2010.pdf', 'zetpol-2010ep.pdf', 'zetpol-2010h.pdf', 'zetpol-2010l.pdf', 'zetpol-2020.pdf', 'zetpol-2020ep.pdf', 'zetpol-2030l.pdf', 'zetpol-2230lx.pdf', 'zetpol-2510.pdf', 'zetpol-3310.pdf', 'zetpol-3310ep.pdf', 'zetpol-3610.pdf', 'zetpol-3710.pdf', 'zetpol-4300.pdf', 'zetpol-4300ep.pdf', 'zetpol-4310.pdf', 'zetpol-4310ep.pdf'];
	if ($('.single-product_head').length) {

		console.log('Run product PDF filter.');
		var productTitle = $('.single-product_head').text().toLowerCase();
		var pdfStart = false;

		if (productTitle.indexOf("zetpol") !== -1) {
			console.log('Product Zetpol');
			pdfStart = ['zetpol', 'zeoforte', 'chemisat'];
		} else if (productTitle.indexOf("nipol") !== -1) {
			console.log('Product Nipol');
			pdfStart = ['nipol', 'sivic', 'zealloy'];
		} else if (productTitle.indexOf("hytemp") !== -1) {
			console.log('Product Hytemp');
			pdfStart = ['hytemp'];
		} else if (productTitle.indexOf("hydrin") !== -1) {
			console.log('Product Hydrin');
			pdfStart = ['hydrin'];
		} else {
			console.log('No product type found.');
		}

		var pdfsLinked = 0;
		$('th.column-1').each(function () {
			if (pdfStart && $(this).text() == 'Product Grade') {
				var gradeTable = $(this).closest('table');
				gradeTable.find('td.column-1').each(function () {
					for (var i = 0, len = pdfStart.length; i < len; i++) {
						var productStr = pdfStart[i] + '-' + $(this).text() + '.pdf';
						productStr = productStr.replace(/\s+/g, '-').toLowerCase();

						if (gradeLinks.indexOf(productStr) >= 0) {
							$(this).wrapInner('<strong></strong>');
							pdfsLinked++;
						}
					}
				});
			}
		});
		// console.log( pdfsLinked + ' PDF Links Created.');
	}

	/**
  * Captures Google Analytics Client ID and inputs into hidden form field
  */
	function fillClientId() {
		// ga does not exist on local or staging.
		if (typeof ga === "undefined") return;
		// Capture Client ID
		var clientId = ga.getAll()[0].get('clientId');
		// Populate hidden form field with Client ID
		jQuery('.g-id input').val(clientId);
	}

	// On pages with client ID form field, populate
	if (jQuery('.g-id input').length) {
		// Give GTM time to load
		setTimeout(function () {
			fillClientId();
		}, 2000);
	}
});